import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { EstacaoService } from 'src/services/estacao.service';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';
import * as moment from 'moment';
import { VariavelService } from 'src/services/variavel.service';
import { MonitoramentoService } from 'src/services/monitoramento.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { normalizarEventoDialog } from 'src/app/shared/evento-total';
import {
  classificarCorColeta,
  corFundoDiaMonitoramento,
  parsePercentualColeta,
} from './classificacao-coleta';

const EVENTOS_TOTAL_IRREGULAR = [1, 3, 4, 5, 9];
const MONITORAMENTO_ESTACOES_STATE_KEY = 'monitoramento-estacoes-state';

@Component({
    selector: 'app-resumo-evento',
    templateUrl: './resumo-evento.component.html',
    styleUrls: ['./resumo-evento.component.scss'],
    standalone: false
})
export class ResumoEventoComponent implements OnInit, AfterViewInit, OnDestroy {
  rangeDate: any[] = [];
  loading: boolean = false
  loadingEnviarEmail: boolean = false
  modalEventosMonitoramentos: boolean = false
  modalMonitoramentoPronto: boolean = false
  dados_monitoramento: any
  tipo_observacao: any
  observacoes: any
  div_obersavacao: boolean = false
  div_email: boolean = false
  data: any[] = [];
  dataGridExibida: any[] = [];
  data_monitoramento: any
  email_para: any = 2;
  columns: any[] = [];
  columnsDialog: any[] = [];
  tipo_variavel: any[] = [];
  dropDownEstacao: any[] = [];
  dropDownTipoVariavel: any[] = [];
  valueDialog: any[] = [];
  eventosDataSelecionada: any[] = [];
  dropDownEvento: any[] = [
    {value: 1, label: 'Bateria baixa'},
    {value: 2, label: 'Painel baixa potencia'},
    {value: 3, label: 'Nivel travado'},
    {value: 4, label: 'Nível oscilante'},
    {value: 5, label: 'Nivel fora dos limites'},
    {value: 6, label: 'Chuva'},
    {value: 7, label: 'Coleta'},
    {value: 8, label: 'Integração'},
  ];
  dropDownEmail: any[] = [
    {value: 2, label: 'Todos'},
    {value: 1, label: 'Internos'},
    {value: 0, label: 'Externos'},
  ];
  estacaoSelecionada: any
  array_monitoramento: any[] = [
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 1,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
      
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 2,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 3,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 4,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 5,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 6,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 9,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 7,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
    {
      data_hora_monitoramento: null,
      data_hora_ultima_situacao: null,
      tipo_evento_id: 8,
      status: null,
      observacao_abertura: '',
      observacao_fechamento: '',
    },
  ];
  estacao_id: any
  jsonData: any[] = [];
  load: boolean = false
  buscaGrid: string = ''
  filtroGridComMonitoramento: boolean = false
  filtroGridMonitoramentoAberto: boolean = false
  isHidden: boolean = false;
  modalVariaveis: boolean = false;
  modalMonitoramento: boolean = false;
  tituloModal: any
  tituloModalMonitoramento: any
  displayObservacaoAberturaMonitoramento: boolean
  displayObservacaoEncerramentoMonitoramento: boolean
  exibirFiltroAvancado: boolean = false
  modalNovoGrupo: boolean = false
  dropDownGrupos: any[] = [];
  dropDownSensores: any[] = [];
  dropDownClientes: any[] = [];
  clientesFiltrados: any[] = [];
  grupo: any
  sensor: any
  cliente: any
  cfg_evento: any

  plu_filtro: any
  flu_filtro: any
  integrador_filtro: any[] = []
  coletor_filtro: any[] = []
  dropDownIntegradores: any[] = []
  dropDownColetores: any[] = []

  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  @ViewChild('dt', { static: false }) dataTable?: Table;
  scrollHeight: string = '600px';
  private scrollHeightBasePx: number = 600;
  private readonly VIRTUAL_ROW_HEIGHT_SIMPLIFICADO = 48;
  private readonly VIRTUAL_ROW_HEIGHT_COMPLETO = 146;
  private readonly PREVIEW_LINHA_EXTRA_ALTURA =
    this.VIRTUAL_ROW_HEIGHT_COMPLETO - this.VIRTUAL_ROW_HEIGHT_SIMPLIFICADO;
  private readonly PREVIEW_LINHA_ALTURA_LIMITE = 600;
  private alturaVirtualScrollerAntesPreview: number | null = null;
  private filtrosPreservadosPendentes: any = null;
  tableMinWidth: string = '1200px';
  private scrollRestauracaoPendente: { top: number; left: number; rowIndex?: number; rowId?: any } | null = null;

  constructor(
    protected _estacaoService: EstacaoService,
    protected _resumoEventoService: ResumoEventoDiaService,
    protected _variavelService: VariavelService,
    protected _monitoramentoService: MonitoramentoService,
    protected _estacaoGrupoService: EstacaoGrupoService,
    protected _pessoaService: PessoaService,
    protected _sensorService: SensorService,
    protected permissaoService: PermissoesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private layoutService: LayoutService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    // A legenda agora fica no card flutuante do componente
    this.layoutService.state.footerLegendVisible = false;
    
    // Verifica se há filtros preservados vindo do relatório
    const navigation = this.router.getCurrentNavigation();
    const navigationState = navigation?.extras?.state || history.state;
    const estadoRestauracao = this.obterEstadoRestauracao();
    
    // Armazena o state para restaurar após carregar os dropdowns
    const filtrosPreservados = estadoRestauracao?.filtros
      ? estadoRestauracao.filtros
      : (navigationState && navigationState.rangeDate ? navigationState : null);
    this.filtrosPreservadosPendentes = filtrosPreservados;
    this.scrollRestauracaoPendente = estadoRestauracao?.scroll ?? null;
    
    this.listEstacoes()
    this.dropDownTipoVariavel = []
    this._variavelService.getType().subscribe(json => {
      json.map(item => {
        this.dropDownTipoVariavel.push({
          label: item.tipo_variavel, value: item.id
        })
      })
    })
    this.listGrupos()
    this.listSensores()
    this.listClientes()
    
  }

  listClientes(){
    this.dropDownClientes = []
    this._pessoaService.index().subscribe(json => {
      let ret = json.filter(x => x.ativo == true)
      ret.map(item => {
        this.dropDownClientes.push({
          label: item.nome, value: item.id
        })
        
      })
    })
  }

  toggleFiltroAvancado(): void {
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  listGrupos(){
    this.dropDownGrupos = []
    this._estacaoGrupoService.index().subscribe(json => {
      json.map(item => {
        this.dropDownGrupos.push({
          label: item.nome, value: item.id
        })
        
      })
    })
  }

  filtrarClientes(event) {
    let query = event.query;
    this._pessoaService.autocomplete(query).subscribe((json) => {
        let clientes = [];
        json.map((item) => {
            clientes.push({
                value: item.value,
                label: item.label,
            });
            this.clientesFiltrados = clientes;
        });
    });
}

listSensores(){
  this.dropDownSensores = []
  this._sensorService.index().subscribe(json => {
    json.map(item => {
      
        this.dropDownSensores.push({
          value: item.id, label: item.descricao,
        })
  
     
    })
  })
}


  
  toggleMonitoramento(){
    this.isHidden = !this.isHidden;
    
  }

  listEstacoes(){
    this.dropDownEstacao = []
    this._estacaoService.lookup().subscribe(json => {
      json.map(item => {
        this.dropDownEstacao.push({
          label: item.descricao, value: item.id
        })
      })
      this.aplicarFiltrosIniciais();
    })
  }

  private aplicarFiltrosIniciais(): void {
    if (this.filtrosPreservadosPendentes) {
      const filtrosPreservados = this.filtrosPreservadosPendentes;
      this.filtrosPreservadosPendentes = null;

      setTimeout(() => {
        this.rangeDate = Array.isArray(filtrosPreservados.rangeDate)
          ? filtrosPreservados.rangeDate
              .filter((data: any) => !!data)
              .map((data: any) => data instanceof Date ? data : new Date(data))
          : [];
        this.estacao_id = filtrosPreservados.estacao_id;
        this.grupo = filtrosPreservados.grupo;
        this.cliente = filtrosPreservados.cliente;
        this.sensor = filtrosPreservados.sensor;
        this.plu_filtro = filtrosPreservados.plu_filtro;
        this.flu_filtro = filtrosPreservados.flu_filtro;
        this.integrador_filtro = filtrosPreservados.integrador_filtro || [];
        this.coletor_filtro = filtrosPreservados.coletor_filtro || [];
        this.versao = filtrosPreservados.versao || this.versao;
        this.exibirFiltroAvancado = !!filtrosPreservados.exibirFiltroAvancado;

        if (this.rangeDate && this.rangeDate.length > 0) {
          this.filtrar();
        }
      }, 300);
      return;
    }

    const ontem = moment().subtract(1, 'day');
    const inicioPeriodo = ontem.clone().subtract(6, 'days');

    // Não auto-selecionar todas as estações nem disparar filtro pesado no init.
    // Usuário aplica filtros e clica em Pesquisar (evita saturar API/DB).
    this.rangeDate = [inicioPeriodo.toDate(), ontem.toDate()];
    this.estacao_id = [];
  }

  getDashboardQueryParams(): { dataInicial: string; dataFinal: string } {
    const dataInicial = this.rangeDate?.[0]
      ? moment(this.rangeDate[0]).format('YYYY-MM-DD')
      : moment().subtract(6, 'days').format('YYYY-MM-DD');
    const dataFinal = moment().format('YYYY-MM-DD');

    return {
      dataInicial,
      dataFinal,
    };
  }

  prepararNavegacaoGraficos(rowData: any): void {
    if (!rowData?.estacao_id || !this.permissaoService.can('estacoes_visualizar')) {
      return;
    }

    this.salvarEstadoTela();
  }

  trackByEstacao(index: number, rowData: any): any {
    return rowData?.estacao_id ?? index;
  }

  versao: string = '0';

  /** PONTO-RETORNO-LINHA-PREVIEW: expandir linha ao clicar na visualização simplificada */
  linhaPreviewCompletaEstacaoId: number | null = null;

  linhaEstaEmPreviewCompleta(rowData: any): boolean {
    return this.versao === '0'
      && this.linhaPreviewCompletaEstacaoId != null
      && Number(rowData?.estacao_id) === Number(this.linhaPreviewCompletaEstacaoId);
  }

  exibirConteudoCompletoLinha(rowData: any): boolean {
    return this.versao === '1' || this.linhaEstaEmPreviewCompleta(rowData);
  }

  onClicarCelulaDiaGrid(rowData: any, event: Event): void {
    if (this.versao !== '0') {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (target?.closest('button, a')) {
      return;
    }

    this.linhaPreviewCompletaEstacaoId = Number(rowData.estacao_id);
    this.ajustarAlturaVirtualScrollerPreview();
  }

  onMouseLeaveLinhaGrid(rowData: any): void {
    if (this.versao !== '0') {
      return;
    }

    if (this.linhaEstaEmPreviewCompleta(rowData)) {
      this.linhaPreviewCompletaEstacaoId = null;
      this.ajustarAlturaVirtualScrollerPreview();
    }
  }

  getBackgroundColor(percentualIntegracao: string): string {
    return classificarCorColeta({
      quantidade: null,
      esperado: null,
      minimoRegistros: null,
      percentual: parsePercentualColeta(percentualIntegracao),
      fallback: '#ffffff',
    });
  }

  integracaoDesligada(rowData: any): boolean {
    const valor = rowData?.desativar_integracao;
    return valor === true || valor === 1 || valor === '1' || valor === 't' || valor === 'true';
  }

  getBackgroundColorForDay(rowData: any, dataResumo: string): string {
    return corFundoDiaMonitoramento(rowData, moment(dataResumo).format('YYYY-MM-DD'));
  }

  getTooltipText(evento: any): string {
    if (evento.tipo_evento_id === 7) {
      if (this.versao === '0') {
        return `${evento.tipo_evento.descricao} - ${evento.percentual_integracao}`;
      } else {
        return `${evento.tipo_evento.descricao}\nDisponibilidade: ${evento.disponibilidade}\nAtraso Médio: ${evento.atraso_medio_integracao || 'N/A'}\nPercentual: ${evento.percentual_integracao}`;
      }
    }
    return evento.tipo_evento.descricao;
  }

  private montarParametrosFiltroApi(estacoesOverride?: number[]): {
    estacoes: number[];
    grupos: number[];
    clientes: number[];
    sensores: number[];
    integradores: number[];
    coletores: number[];
  } {
    const estacoes: number[] = estacoesOverride ? [...estacoesOverride] : [];
    const grupos: number[] = [];
    const clientes: number[] = [];
    const sensores: number[] = [];
    const integradores: number[] = [];
    const coletores: number[] = [];

    if (!estacoesOverride && this.estacao_id) {
      this.estacao_id.forEach(item => {
        estacoes.push(item.value);
      });
    }
    if (this.grupo) {
      this.grupo.forEach(item => {
        grupos.push(item.value);
      });
    }
    if (this.cliente) {
      this.cliente.forEach(item => {
        clientes.push(item.value);
      });
    }
    if (this.sensor) {
      this.sensor.forEach(item => {
        sensores.push(item.value);
      });
    }
    if (this.integrador_filtro) {
      this.integrador_filtro.forEach(item => {
        integradores.push(item.id);
      });
    }
    if (this.coletor_filtro) {
      this.coletor_filtro.forEach(item => {
        coletores.push(item.id);
      });
    }

    return { estacoes, grupos, clientes, sensores, integradores, coletores };
  }

  private obterDataInicioAtualizacaoParcial(): string {
    const inicioPeriodo = moment(this.rangeDate[0]).startOf('day');
    const candidatos: moment.Moment[] = [];

    if (this.data_monitoramento) {
      candidatos.push(moment(this.data_monitoramento).startOf('day'));
    }
    if (this.novoMonitoramento?.data_hora_monitoramento) {
      candidatos.push(moment(this.novoMonitoramento.data_hora_monitoramento).startOf('day'));
    }
    if (this.novoMonitoramento?.data_hora_ultima_situacao) {
      candidatos.push(moment(this.novoMonitoramento.data_hora_ultima_situacao).startOf('day'));
    }

    if (!candidatos.length) {
      return inicioPeriodo.format('YYYY-MM-DD');
    }

    return moment.max(moment.min(candidatos), inicioPeriodo).format('YYYY-MM-DD');
  }

  private capturarScrollAtual(): { top: number; left: number } {
    const scrollBody = this.getTableScrollBody();
    return {
      top: scrollBody?.scrollTop ?? 0,
      left: scrollBody?.scrollLeft ?? 0,
    };
  }

  private restaurarScrollCapturado(scroll: { top: number; left: number }, tentativa: number = 0): void {
    const scrollBody = this.getTableScrollBody();
    if (!scrollBody) {
      if (tentativa < 6) {
        setTimeout(() => this.restaurarScrollCapturado(scroll, tentativa + 1), 80);
      }
      return;
    }

    scrollBody.scrollTop = scroll.top;
    scrollBody.scrollLeft = scroll.left;

    if (tentativa < 3) {
      setTimeout(() => this.restaurarScrollCapturado(scroll, tentativa + 1), 100);
    }
  }

  private mesclarDadosLinhaEstacao(rowIndex: number, itemApi: any, dataInicio: string): void {
    const row = this.data[rowIndex];
    const diaLimite = moment(dataInicio).format('YYYY-MM-DD');

    this.cfg_evento = itemApi.configuracoes_evento;
    const novosEventos = this.processarEventos(itemApi.eventos || []);
    const novosMonitoramentos = this.removerDuplicados(
      this.processarMonitoramentos(itemApi.monitoramentos || [])
    );

    const eventosPreservados = (row.eventos || []).filter(
      (evento: any) => moment(evento.data_resumo).format('YYYY-MM-DD') < diaLimite
    );
    const monitoramentosPreservados = (row.monitoramento || []).filter(
      (mon: any) => mon.dataMonitoramento < diaLimite
    );

    const eventosMesclados = [...eventosPreservados, ...novosEventos];
    this.sortByKey(eventosMesclados, 'tipo_evento_id');

    this.data[rowIndex] = {
      ...row,
      desativar_integracao: Object.prototype.hasOwnProperty.call(itemApi, 'desativar_integracao')
        ? (itemApi.desativar_integracao === true || itemApi.desativar_integracao === 1 || itemApi.desativar_integracao === '1')
        : row.desativar_integracao === true,
      eventos: eventosMesclados,
      monitoramento: this.removerDuplicados([...monitoramentosPreservados, ...novosMonitoramentos]),
      configuracoes_evento: itemApi.configuracoes_evento ?? row.configuracoes_evento,
    };
    this.data = [...this.data];
  }

  atualizarLinhaEstacaoAposSalvar(estacaoId?: number, dataInicio?: string): void {
    const estacao = estacaoId ?? this.estacaoSelecionada;
    if (!estacao || !this.rangeDate?.length || !this.data?.length) {
      return;
    }

    const rowIndex = this.data.findIndex((row: any) => Number(row.estacao_id) === Number(estacao));
    if (rowIndex < 0) {
      return;
    }

    const inicio = dataInicio ?? this.obterDataInicioAtualizacaoParcial();
    const fim = moment(this.rangeDate[1]).format('YYYY-MM-DD');
    const scroll = this.capturarScrollAtual();
    const { grupos, clientes, sensores, integradores, coletores } = this.montarParametrosFiltroApi();

    this._resumoEventoService.filter(
      inicio,
      fim,
      [estacao],
      grupos,
      clientes,
      sensores,
      this.plu_filtro,
      this.flu_filtro,
      integradores,
      coletores
    ).subscribe({
      next: (json) => {
        const item = Array.isArray(json) ? json.find((row: any) => Number(row.id) === Number(estacao)) : null;
        if (!item) {
          return;
        }

        this.mesclarDadosLinhaEstacao(rowIndex, item, inicio);
        this.atualizarDataGridExibida();
        setTimeout(() => {
          this.restaurarScrollCapturado(scroll);
          this.limitarScrollVerticalGrid();
        }, 0);
      },
      error: (err) => {
        console.error('Erro ao atualizar linha da estação:', err);
      }
    });
  }

  private filtroSub?: Subscription;

  filtrar() {
    this.linhaPreviewCompletaEstacaoId = null;
    this.alturaVirtualScrollerAntesPreview = null;
    this.load = true;
    this.buscaGrid = '';
    this.filtroGridComMonitoramento = false;
    this.filtroGridMonitoramentoAberto = false;
    const { estacoes, grupos, clientes, sensores, integradores, coletores } = this.montarParametrosFiltroApi();

    if (
      (!estacoes || estacoes.length === 0)
      && (!grupos || grupos.length === 0)
      && (!clientes || clientes.length === 0)
      && (!sensores || sensores.length === 0)
    ) {
      this.load = false;
      this.messageService.add({
        severity: 'warn',
        summary: 'Filtro necessário',
        detail: 'Selecione ao menos uma estação, grupo, cliente ou sensor antes de pesquisar.',
      });
      return;
    }
  
    const inicioData = moment(this.rangeDate[0]).format('YYYY-MM-DD');
    const fimData = moment(this.rangeDate[1]).format('YYYY-MM-DD');

    this.filtroSub?.unsubscribe();
    this.filtroSub = this._resumoEventoService.filter(inicioData, fimData, estacoes, grupos, clientes, sensores, this.plu_filtro, this.flu_filtro, integradores, coletores).subscribe(json => {
      const weekdays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
  
      this.columns = [];
      this.data = [];
      this.dataGridExibida = [];
  
      let currentDate = new Date(this.rangeDate[0]);
  
      // Gerar as colunas com os dias da semana
      while (currentDate <= new Date(this.rangeDate[1])) {
        const dayOfWeek = weekdays[currentDate.getDay()];
        const formattedDate = moment(currentDate).format('DD/MM/YYYY');
        this.columns.push({
          field: `${formattedDate} ${dayOfWeek}`,
          header: `${dayOfWeek} ${formattedDate}`,
          data_resumo: moment(currentDate).format('YYYY-MM-DD'),
          eventos: [],
          monitoramentos: []
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      this.tableMinWidth = `${120 + (this.columns.length * 100)}px`;
  
      // Processar os dados dos eventos e monitoramentos
      if (json) {
        json.forEach(item => {
          this.cfg_evento = item.configuracoes_evento
          const eventos = this.processarEventos(item.eventos || []);
          const monitoramento = this.processarMonitoramentos(item.monitoramentos || []);
  
          this.sortByKey(eventos, 'tipo_evento_id')

          this.data.push({
            estacao_id: item.id,
            descricao: item.descricao,
            desativar_integracao: item.desativar_integracao === true || item.desativar_integracao === 1 || item.desativar_integracao === '1',
            data_resumo: item.eventos ? item.eventos[0]?.data_resumo : '',
            eventos: eventos,
            monitoramento: this.removerDuplicados(monitoramento),
            configuracoes_evento: item.configuracoes_evento ?? []
          });
        });
      }

      this.atualizarDataGridExibida();

      this.load = false;
      setTimeout(() => {
        this.calculateScrollHeight();
        this.restaurarScrollDaTela();
        this.limitarScrollVerticalGrid();
      }, 500);
    }, err => {
      this.load = false;
    });
  }
  
  onBuscaGridChange(): void {
    this.linhaPreviewCompletaEstacaoId = null;
    this.alturaVirtualScrollerAntesPreview = null;
    this.atualizarDataGridExibida();
    this.ajustarScrollAposFiltroGrid();
  }

  toggleFiltroGridComMonitoramento(): void {
    this.filtroGridComMonitoramento = !this.filtroGridComMonitoramento;
    if (!this.filtroGridComMonitoramento) {
      this.filtroGridMonitoramentoAberto = false;
    }
    this.onBuscaGridChange();
  }

  toggleFiltroGridMonitoramentoAberto(): void {
    if (!this.filtroGridComMonitoramento) {
      return;
    }
    this.filtroGridMonitoramentoAberto = !this.filtroGridMonitoramentoAberto;
    this.onBuscaGridChange();
  }

  private estacaoTemMonitoramentoNoPeriodo(row: any): boolean {
    return Array.isArray(row?.monitoramento) && row.monitoramento.length > 0;
  }

  private estacaoTemMonitoramentoAbertoNoPeriodo(row: any): boolean {
    return (row?.monitoramento || []).some((mon: any) => Number(mon.status) === 0);
  }

  private atualizarDataGridExibida(): void {
    let rows = this.data;

    if (this.filtroGridComMonitoramento) {
      rows = rows.filter((row) => this.estacaoTemMonitoramentoNoPeriodo(row));
    }

    if (this.filtroGridMonitoramentoAberto) {
      rows = rows.filter((row) => this.estacaoTemMonitoramentoAbertoNoPeriodo(row));
    }

    const termo = this.normalizarTextoBusca((this.buscaGrid ?? '').trim());
    if (termo) {
      rows = rows.filter((row) => this.linhaCorrespondeBuscaGrid(row, termo));
    }

    this.dataGridExibida = rows;
  }

  private ajustarScrollAposFiltroGrid(): void {
    setTimeout(() => {
      const scrollBody = this.getTableScrollBody();
      if (scrollBody) {
        scrollBody.scrollTop = 0;
      }
      if (this.dataTable) {
        try {
          this.dataTable.scrollToVirtualIndex(0);
        } catch {}
      }
      this.limitarScrollVerticalGrid();
    }, 0);
  }

  private limitarScrollVerticalGrid(): void {
    setTimeout(() => {
      const scrollBody = this.getTableScrollBody();
      if (!scrollBody) {
        return;
      }

      const itemSize = this.virtualRowHeight;
      const totalRows = this.dataGridExibida.length;
      const contentHeight = totalRows * itemSize;
      const maxScrollTop = Math.max(0, contentHeight - scrollBody.clientHeight);

      if (scrollBody.scrollTop > maxScrollTop) {
        scrollBody.scrollTop = maxScrollTop;
      }

      if (this.dataTable && totalRows > 0) {
        const indiceMaximo = Math.max(0, totalRows - 1);
        const indiceAtual = Math.floor(scrollBody.scrollTop / itemSize);
        if (indiceAtual > indiceMaximo) {
          try {
            this.dataTable.scrollToVirtualIndex(indiceMaximo);
          } catch {}
        }
      }
    }, 80);
  }

  private normalizarTextoBusca(valor: string): string {
    return valor
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private montarTextoBuscaGrid(rowData: any): string {
    const tokens: string[] = [];
    const add = (valor: any) => {
      if (valor !== null && valor !== undefined && String(valor).trim() !== '') {
        tokens.push(String(valor));
      }
    };

    add(rowData.descricao);
    add(rowData.estacao_id);

    (rowData.eventos || []).forEach((ev: any) => {
      add(ev.tipo_evento?.descricao);
      add(ev.tooltip);
      add(ev.total_computado);
      add(ev.disponibilidade);
      add(ev.percentual_coleta);
      add(ev.percentual_integracao);
      add(ev.atraso_medio_integracao);
      add(ev.data_resumo);
      if (ev.data_resumo) {
        add(moment(ev.data_resumo).format('DD/MM/YYYY'));
        add(moment(ev.data_resumo).format('dddd'));
      }
    });

    (rowData.monitoramento || []).forEach((mon: any) => {
      add(mon.tipo_evento?.descricao);
      add(mon.dataMonitoramento);
      add(mon.problema);
      add(mon.desfecho);
      if (mon.dataMonitoramento) {
        add(moment(mon.dataMonitoramento).format('DD/MM/YYYY'));
        add(moment(mon.dataMonitoramento).format('dddd'));
      }
      const catKey = this.determinarCategoriaMonitoramento(mon.tipo_evento_id);
      const cfg = this.CATEGORIAS_MONITORAMENTO.find(c => c.key === catKey);
      add(cfg?.label);
    });

    return this.normalizarTextoBusca(tokens.join(' '));
  }

  private linhaCorrespondeBuscaGrid(rowData: any, termo: string): boolean {
    return this.montarTextoBuscaGrid(rowData).includes(termo);
  }

  // Função para processar os eventos
  processarEventos(eventos: any[]): any[] {
    return eventos.map(evento => {
      if (evento.data_resumo != null && evento.data_resumo !== '') {
        evento.data_resumo = moment(evento.data_resumo).format('YYYY-MM-DD');
      }
      let cfg = this.cfg_evento.find(x => x.configuracao_evento_id == evento.tipo_evento_id)
      if (EVENTOS_TOTAL_IRREGULAR.includes(Number(evento.tipo_evento_id))) {
        evento.total_computado = Number(evento.total_computado_irregular ?? 0)
      } else if(cfg.tipo_criterio_pelo_irregural_regular == 0){
        evento.total_computado = evento.total_computado_irregular
      } else if(cfg.tipo_criterio_pelo_irregural_regular == 1){
        evento.total_computado = evento.total_computado_normal
      }
      if (Number(evento.tipo_evento_id) === 7) {
        const numColeta = Number(evento.total_computado_normal ?? 0);
        const denColeta = Number(evento.maximo_normalidade_eventos ?? 0);
        evento.percentual_coleta = denColeta > 0
          ? `${((numColeta / denColeta) * 100).toFixed(2).replace('.', ',')} %`
          : '0,00 %';
      } else {
        evento.percentual_coleta = null;
      }
      if(evento.tipo_evento.descricao == 'BATERIA BAIXA'){
        evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados de bateria baixa (<=' + cfg.valor_parametro + 'V) no dia. O máximo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
      } else if(evento.tipo_evento.descricao == 'PAINEL BAIXA POTENCIA'){
       evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados de painel com boa potencia (>=' + cfg.valor_parametro + 'V) no dia. O minimo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
      } else if(evento.tipo_evento.descricao == 'NIVEL TRAVADO'){
        evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados iguais (H = H-1) durante o dia. O máximo de dados iguais são '+evento.maximo_normalidade_eventos + ' ao dia.'
      } else if (
        evento.tipo_evento.descricao === 'NIVEL OSCILANTE' ||
        evento.tipo_evento.descricao === 'NIVEL OCILANTE'
      ) {
        evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados com variação acima do desvio padrão aceitável (DP³ = +/-'+cfg.valor_parametro+' CM) no dia. O máximo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
      } else if(evento.tipo_evento.descricao == 'NIVEL FORA DOS LIMITES'){
         evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados fora dos parâmetros mínimos e máximo (limite superior '+cfg.valor_maximo+' cm, limite inferior '+cfg.valor_minimo+') no dia. O máximo são ' + evento.maximo_normalidade_eventos + ' dados fora dos limites ao dia.'
      } else if(evento.tipo_evento.descricao == 'CHUVA'){
        const horas = cfg?.quantidade_anterior_acumular;
        const periodo = horas != null && horas !== ''
          ? `nas últimas ${horas} horas`
          : 'no período configurado';
        if (Number(evento.situaca_evento) === 0) {
          evento.tooltip = `Existe registro de chuva ≥ 0,2 mm ${periodo}.`;
        } else {
          evento.tooltip = `Não há registro de chuva ≥ 0,2 mm ${periodo}.`;
        }
      } else if(evento.tipo_evento.descricao == 'CHUVA SUSPEITA'){
        evento.tooltip = 'Foram encontrados ' + evento.total_computado + ' dados com chuva acumulada suspeita (>= ' + cfg.valor_parametro + 'mm em 1 hora) no dia. O máximo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
      } else if(evento.tipo_evento.descricao == 'COLETA'){
evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados apenas no dia para este coletor. O mínimo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
      } else if(evento.tipo_evento.descricao == 'INTEGRAÇÃO'){
        evento.tooltip = 'Foram encontrados ' + evento.total_computado +' dados com integração correta apenas no dia. O mínimo são ' + evento.maximo_normalidade_eventos + ' dados ao dia.'
                 }
      evento.cor = evento.situaca_evento === 0 ? '#6c8f3f' : '#b0662f';
      return evento;
    }).sort((a, b) => a.tipo_evento_id - b.tipo_evento_id);
  }
  
  // Função para processar os monitoramentos
  processarMonitoramentos(monitoramentos: any[]): any[] {
    return monitoramentos.map(mon => {
      mon.cor = this.determinarCorMonitoramento(mon.tipo_evento_id);
      return mon;
    });
  }
  
  // Função para determinar a cor do monitoramento
  determinarCorMonitoramento(tipoEventoId: number): string {
    switch (tipoEventoId) {
      case 7:
      case 8:
        return 'red';
      case 1:
      case 2:
        return 'orange';
      case 3:
      case 4:
      case 5:
        return 'blue';
      case 6:
      case 9:
        return 'gray';
      default:
        return 'black'; // Cor padrão caso não se encaixe em nenhum tipo
    }
  }

  getIconeEvento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.tipo_evento?.icone || row?.icone || '';
  }

  getIconeMonitoramento(mon: any): string {
    if (Number(mon?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return mon?.tipo_evento?.icone || mon?.icone || 'fa-regular fa-circle-dot';
  }

  private readonly CATEGORIAS_MONITORAMENTO = [
    { key: 'integracao_coleta', tipos: [7, 8], cor: 'red', label: 'Monitoramento Integração/Coleta', icone: 'fa-regular fa-circle-dot' },
    { key: 'bateria_painel', tipos: [1, 2], cor: 'orange', label: 'Monitoramento Bateria/Painel', icone: 'fa-regular fa-circle-dot' },
    { key: 'nivel', tipos: [3, 4, 5], cor: 'blue', label: 'Monitoramento Nível', icone: 'fa-regular fa-circle-dot' },
    { key: 'chuva', tipos: [6, 9], cor: 'gray', label: 'Monitoramento Chuva', icone: 'fa-regular fa-circle-dot' },
  ];

  determinarCategoriaMonitoramento(tipoEventoId: number): string | null {
    const cat = this.CATEGORIAS_MONITORAMENTO.find(c => c.tipos.includes(Number(tipoEventoId)));
    return cat?.key ?? null;
  }

  getMonitoramentosIconesNaData(rowData: any, dataResumo: string): any[] {
    const dia = moment(dataResumo).format('YYYY-MM-DD');
    const monitoramentos = rowData.monitoramento?.filter((mon: any) => mon.dataMonitoramento === dia) || [];
    const categorias = new Map<string, any>();

    monitoramentos.forEach((mon: any) => {
      const catKey = this.determinarCategoriaMonitoramento(mon.tipo_evento_id);
      if (!catKey || categorias.has(catKey)) {
        return;
      }
      const cfg = this.CATEGORIAS_MONITORAMENTO.find(c => c.key === catKey);
      categorias.set(catKey, {
        key: catKey,
        cor: cfg?.cor ?? this.determinarCorMonitoramento(mon.tipo_evento_id),
        label: cfg?.label ?? mon.tipo_evento?.descricao,
        icone: cfg?.icone ?? 'fa-regular fa-circle-dot',
      });
    });

    return Array.from(categorias.values());
  }

  private obterMonitoramentoPrincipalNoDia(monitoramentos: any[], dia: string): number | null {
    const noDia = monitoramentos.filter((mon: any) => mon.dataMonitoramento === dia);
    if (!noDia.length) {
      return null;
    }

    const aberto = noDia.find((mon: any) => Number(mon.status) === 0);
    if (aberto) {
      return Number(aberto.id);
    }

    return noDia.reduce(
      (maiorId: number, mon: any) => Math.max(maiorId, Number(mon.id)),
      Number(noDia[0].id)
    );
  }

  getFaixaMonitoramentoDia(rowData: any, dataResumo: string): {
    ativo: boolean;
    posicao: 'inicio' | 'meio' | 'fim' | 'unico' | null;
    aberto: boolean;
    dataInicio: string | null;
    dataFim: string | null;
    continuaAntes: boolean;
    continuaDepois: boolean;
  } {
    const dia = moment(dataResumo).format('YYYY-MM-DD');
    const monitoramentos = rowData.monitoramento || [];
    const monId = this.obterMonitoramentoPrincipalNoDia(monitoramentos, dia);

    if (monId === null) {
      return {
        ativo: false,
        posicao: null,
        aberto: false,
        dataInicio: null,
        dataFim: null,
        continuaAntes: false,
        continuaDepois: false,
      };
    }

    const registros = monitoramentos.filter((mon: any) => Number(mon.id) === monId);
    const dias = Array.from(
      new Set<string>(registros.map((mon: any) => String(mon.dataMonitoramento)))
    ).sort((a, b) => a.localeCompare(b));
    const monRef = registros[0];
    const aberto = Number(monRef?.status) === 0;

    const indicesVisiveis = this.columns
      .map((col, indice) => (dias.includes(col.data_resumo) ? indice : -1))
      .filter((indice) => indice >= 0);

    const idxAtual = this.columns.findIndex((col) => col.data_resumo === dia);
    const idxPrimeiro = indicesVisiveis[0] ?? idxAtual;
    const idxUltimo = indicesVisiveis[indicesVisiveis.length - 1] ?? idxAtual;

    let posicao: 'inicio' | 'meio' | 'fim' | 'unico';
    if (idxPrimeiro === idxUltimo) {
      posicao = 'unico';
    } else if (idxAtual === idxPrimeiro) {
      posicao = 'inicio';
    } else if (idxAtual === idxUltimo) {
      posicao = 'fim';
    } else {
      posicao = 'meio';
    }

    const dataInicio: string | null = monRef?.data_hora_monitoramento
      ? moment(monRef.data_hora_monitoramento).format('YYYY-MM-DD')
      : (dias[0] ?? null);
    const dataFim: string | null = aberto
      ? null
      : (monRef?.data_hora_ultima_situacao
        ? moment(monRef.data_hora_ultima_situacao).format('YYYY-MM-DD')
        : (dias[dias.length - 1] ?? null));

    const inicioFiltro = this.columns[0]?.data_resumo
      ?? (this.rangeDate?.[0] ? moment(this.rangeDate[0]).format('YYYY-MM-DD') : dia);
    const fimFiltro = this.columns[this.columns.length - 1]?.data_resumo
      ?? (this.rangeDate?.[1] ? moment(this.rangeDate[1]).format('YYYY-MM-DD') : dia);

    const comecaAntesFiltro = !!dataInicio && dataInicio < inicioFiltro;
    const terminaDepoisFiltro = aberto || (!!dataFim && dataFim > fimFiltro);

    const continuaAntes = comecaAntesFiltro && idxAtual === idxPrimeiro;
    const continuaDepois = terminaDepoisFiltro && idxAtual === idxUltimo;

    return {
      ativo: true,
      posicao,
      aberto,
      dataInicio,
      dataFim,
      continuaAntes,
      continuaDepois,
    };
  }

  getClassesFaixaMonitoramento(rowData: any, dataResumo: string): Record<string, boolean> {
    const faixa = this.getFaixaMonitoramentoDia(rowData, dataResumo);
    if (!faixa.ativo || !faixa.posicao) {
      return {};
    }

    return {
      'celula-dia-faixa-monitoramento': true,
      'celula-dia-faixa-monitoramento--aberto': faixa.aberto,
      'celula-dia-faixa-monitoramento--fechado': !faixa.aberto,
      [`celula-dia-faixa-monitoramento--${faixa.posicao}`]: true,
      'celula-dia-faixa-monitoramento--continua-antes': faixa.continuaAntes,
      'celula-dia-faixa-monitoramento--continua-depois': faixa.continuaDepois,
    };
  }

  getTooltipFaixaMonitoramento(rowData: any, dataResumo: string): string {
    const faixa = this.getFaixaMonitoramentoDia(rowData, dataResumo);
    if (!faixa.ativo) {
      return '';
    }

    const inicio = faixa.dataInicio ? moment(faixa.dataInicio).format('DD/MM/YYYY') : '';
    const fim = faixa.aberto
      ? 'em aberto'
      : (faixa.dataFim ? moment(faixa.dataFim).format('DD/MM/YYYY') : '');

    return `Monitoramento de ${inicio} até ${fim}. Clique para abrir.`;
  }

  alterarStatusAtivo(item: any): void {
    console.log(item)
  }
  

//   filtrar(){
//     this.load = true
//     let estacoes: any = []
//     if(this.estacao_id){
//       this.estacao_id.map(item => {
//         estacoes.push(item.value)
//       })
//     }
   
    
//     this._resumoEventoService.filter(
//       moment(this.rangeDate[0]).format('YYYY-MM-DD'), 
//       moment(this.rangeDate[1]).format('YYYY-MM-DD'), 
//       estacoes
//     ).subscribe(json => {
    
//       let currentDate = new Date(this.rangeDate[0]);
//       const weekdays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
//       this.columns = []; 
//       this.data = []; 
    
//       while (currentDate <= new Date(this.rangeDate[1])) {
//         const dayOfWeek = weekdays[currentDate.getDay()];
    
//         this.columns.push({ field: moment(currentDate).format('DD/MM/YYYY') + ' ' + dayOfWeek, header:dayOfWeek + ' ' + moment(currentDate).format('DD/MM/YYYY'),  data_resumo: moment(currentDate).format('YYYY-MM-DD'), eventos: [] , monitoramentos: []});
    
//         currentDate.setDate(currentDate.getDate() + 1);
//       }
    
//       if (json) {
//         let eventos: any[]
//         let monitoramento: any[] = []
//         let data_evento
//         let cor
//         let estacao_id
//         json.map(item => {
//           estacao_id = item.id
//           eventos = []
//           if(item.eventos){
//             item.eventos.map(evento => {
//               data_evento = evento.data_resumo
//               if(evento.situaca_evento == 0){
//                 evento.cor = '#6c8f3f'
//               } else {
//                 evento.cor = '#b0662f'
//               }
//               eventos.push(evento)
//               this.sortByKey(eventos, 'tipo_evento_id', 'asc');
             
//             });
           
//           }

//           if(item.monitoramentos){
//             let cor
//             monitoramento = []
//             item.monitoramentos.map(mon => {
             
               
//                 if(mon.tipo_evento_id == 7 || mon.tipo_evento_id == 8){
//                   cor = 'red'
//                 } else if(mon.tipo_evento_id == 1 || mon.tipo_evento_id == 2){
// cor = 'orange'
//                 } else if(mon.tipo_evento_id == 3 || mon.tipo_evento_id == 4 || mon.tipo_evento_id == 5){
// cor = 'blue'
//                 } else if(mon.tipo_evento_id == 6){
// cor = 'gray'
//                 }

//                 mon.cor = cor
                
//                 monitoramento.push(mon)
              
              
//             })
            
            
//           }

//           let registrosUnicos = this.removerDuplicados(monitoramento)
         
        
          

//           this.data.push({
//             estacao_id: estacao_id,
//             descricao: item.descricao,
//             data_resumo: data_evento,
//             eventos: eventos,
//             monitoramento: registrosUnicos
//           })

         




//         })
       
//       }
//     this.load = false
//     }, err => {
//       this.load = false
//     })
//   }

  removerDuplicados(event){
    let ids = new Set();
    return event.filter(item => {
        const isAberto = Number(item.status) === 0;
        if (!isAberto) {
          if (item.dataMonitoramento > moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD') || item.dataMonitoramento < moment(item.data_hora_monitoramento).format('YYYY-MM-DD')) {
              return false;
          }
        } else if (item.dataMonitoramento < moment(item.data_hora_monitoramento).format('YYYY-MM-DD')) {
          return false;
        }

        let chave = item.id + '_' + item.tipo_evento_id + '_' + item.dataMonitoramento;
        if (ids.has(chave)) {
            return false; 
        }
        ids.add(chave); 
        return true; 
    });
};

  isDateInRange(dateToCheck, startDate, endDate) {
    let date = new Date(dateToCheck);
    let start = new Date(startDate);
    let end = new Date(endDate);
  
    return date >= start && date <= end;
  }

  sortByKey(array, key, type = 'asc') {
    return array.sort(function (a, b) {
      if (type == 'asc') {
        var x = a[key]; var y = b[key];
      } else {
        var x = b[key]; var y = a[key];
      }
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  // listMonitoramentos() {
  //   this.loading = true;
  
  //   // Modelo base para monitoramento
  //   const baseMonitoramento = {
  //     data_hora_monitoramento: null,
  //     data_hora_ultima_situacao: null,
  //     status: null,
  //     observacao_abertura: '',
  //     observacao_fechamento: '',
  //   };
  
  //   // Gerar array dinamicamente
  //   this.array_monitoramento = Array.from({ length: 8 }, (_, i) => ({
  //     ...baseMonitoramento,
  //     tipo_evento_id: i + 1,
  //   }));
  
  //   // Chamar serviço
  //   this._estacaoService.getMonitoramentos(
  //     this.estacaoSelecionada,
  //     this.data_monitoramento
  //   ).subscribe(
  //     (json) => {
  //       json.forEach((item) => {
  //         if (item.status === 0 || item.status === 1) {
  //           const monitoramento = this.array_monitoramento.find(
  //             (x) => x.tipo_evento_id === item.tipo_evento_id
  //           );
  
  //           if (monitoramento) {
  //             // Atualizar monitoramento encontrado
  //             Object.assign(monitoramento, {
  //               id: item.id,
  //               data_hora_monitoramento: moment(item.data_hora_monitoramento).format('YYYY-MM-DD'),
  //               data_hora_ultima_situacao: moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD'),
  //               status: item.status,
  //             });
  //           }
  //         }
  //       });
  
  //       this.filtrar();
  //       this.loading = false;
  //     },
  //     (err) => {
  //       console.error('Erro ao carregar monitoramentos:', err);
  //       this.loading = false;
  //     }
  //   );
  // }
  

//   listMonitoramentos(){
//     this.loading = true
//     this.array_monitoramento = []
//     this.array_monitoramento = [
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 1,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
        
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 2,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 3,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 4,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 5,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 6,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 7,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//       {
//         data_hora_monitoramento: null,
//         data_hora_ultima_situacao: null,
//         tipo_evento_id: 8,
//         status: null,
//         observacao_abertura: '',
//         observacao_fechamento: '',
//       },
//     ];


//     this._estacaoService.getMonitoramentos(this.estacaoSelecionada, moment(this.rangeDate[0]).format('YYYY-MM-DD')).subscribe(json => {
//       json.map(item => {
// if(item.status == 0 || item.status == 1){
//       let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
//       monitoramento.id = item.id
//       monitoramento.data_hora_monitoramento = moment(item.data_hora_monitoramento).format('YYYY-MM-DD')
//       monitoramento.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD')
//       monitoramento.status = item.status
//     } 
      
//       })
    
//       this.filtrar()
      
//      this.loading = false
//     }, err => {
//       this.loading = false
//     })
//   }

  abrirMonitoramento(event){
    let params = event
    params.estacao_id = this.estacaoSelecionada
    params.status = 0
    params.observacao_abertura = this.observacoes
    params.data_hora_monitoramento = this.data_monitoramento + ' 00:00:00'
    params.data_hora_ultima_situacao = new Date()
    this._monitoramentoService.save(params).subscribe((json: any) => {
      
      this._estacaoService.getMonitoramentos(this.estacaoSelecionada, this.data_monitoramento).subscribe(json => {
    
      
        json.map(item => {
          if(item.status == 0 || item.status == 1){
            let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
            monitoramento.id = item.id
            monitoramento.data_hora_monitoramento = moment(item.data_hora_monitoramento).format('YYYY-MM-DD')
            monitoramento.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD')
            monitoramento.status = item.status
          } else if(item.status == 2){
            let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
            monitoramento.desabilitar = true
            monitoramento.status = item.status
          }
         
          
        })

       
       
        })
        let params = {
id: json.id,
tipoUsuario: this.email_para
        }

        this._monitoramentoService.sendEmailMonitoramento(params).subscribe(json =>{
          this.div_obersavacao = false
          this.modalEventosMonitoramentos = true
        })
    })
  }

  hasMonitoramentosNaData(rowData: any, dataResumo: string): boolean {
    return rowData.monitoramento?.some((mon: any) => mon.dataMonitoramento === dataResumo);
  }

  getEventosNaData(rowData: any, dataResumo: string): any[] {
    const dia = moment(dataResumo).format('YYYY-MM-DD');
    return (rowData.eventos || []).filter(
      (row: any) => moment(row.data_resumo).format('YYYY-MM-DD') === dia
    );
  }

  getEventoColetaNaData(rowData: any, dataResumo: string): any | null {
    return this.getEventosNaData(rowData, dataResumo).find(
      (row: any) => Number(row.tipo_evento_id) === 7
    ) ?? null;
  }

  hasEventosNaData(rowData: any, dataResumo: string): boolean {
    return this.getEventosNaData(rowData, dataResumo).length > 0;
  }

  encerrarMonitoramento(event){
    let params = event
    params.data_hora_ultima_situacao = this.data_monitoramento + ' 23:59:59'
    params.status = 2
    params.observacao_fechamento = this.observacoes
    
    this._monitoramentoService.save(params, event.id).subscribe((json: any) => {
     
      this._estacaoService.getMonitoramentos(this.estacaoSelecionada, this.data_monitoramento).subscribe(json => {
    
      
        json.map(item => {
          if(item.status == 0 || item.status == 1){
            let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
            monitoramento.id = item.id
            monitoramento.data_hora_monitoramento = moment(item.data_hora_monitoramento).format('YYYY-MM-DD')
            monitoramento.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD')
            monitoramento.status = item.status
          } else if(item.status == 2){
            let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
            monitoramento.id = item.id
            monitoramento.desabilitar = true
            monitoramento.status = item.status
          }
         
          
        })
        this.div_obersavacao = false
        this.modalEventosMonitoramentos = true
        })
    })
  }

//   apagarEventos(event){
//     let params = {
//       estacaoList: [
//         {
//           id: this.estacaoSelecionada
//         }
//       ],
//       tipoEventoId: event.tipo_evento_id,
// data: this.data_monitoramento
//     }
//     this._resumoEventoService.remake(params).subscribe(json => {
//       this.eventosDataSelecionada = this.eventosDataSelecionada.filter(x => { return x !== event });
//       console.log('json', json)
//     })
//   }
  
  apagarMonitoramento(event){
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: 'Deseja prosseguir com a ação ?',
      accept: () => {
        this._monitoramentoService.destroy(event.id).subscribe(json => {
          this.array_monitoramento = []
          this.array_monitoramento = [
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 1,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 2,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 3,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 4,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 5,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 6,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 9,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 7,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
            {
              data_hora_monitoramento: null,
              data_hora_ultima_situacao: null,
              tipo_evento_id: 8,
              status: null,
              observacao_abertura: '',
              observacao_fechamento: '',
              desabilitar: false
            },
          ];
    this._estacaoService.getMonitoramentos(this.estacaoSelecionada, this.data_monitoramento).subscribe(json => {
        
          
      json.map(item => {
        if(item.status == 0 || item.status == 1){
          let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
          monitoramento.id = item.id
          monitoramento.data_hora_monitoramento = moment(item.data_hora_monitoramento).format('YYYY-MM-DD')
          monitoramento.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD')
          monitoramento.status = item.status
        } else if(item.status == 2){
          let monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id == item.tipo_evento_id)
          monitoramento.id = item.id
          monitoramento.desabilitar = true
          monitoramento.status = item.status
        }
       
        
      })
      this.div_obersavacao = false
      this.modalEventosMonitoramentos = true
      })
        })
      }
  });
  
    
  }


  /**
   * Com vários registros retornados para o dia, prioriza monitoramento em aberto (status 0) e o mais recente.
   */
  private escolherMonitoramentoParaModal(monitoramentos: any[]): any | null {
    if (!monitoramentos?.length) {
      return null;
    }
    const copia = [...monitoramentos];
    copia.sort((a, b) => {
      const sa = Number(a?.status);
      const sb = Number(b?.status);
      if (sa === 0 && sb !== 0) {
        return -1;
      }
      if (sa !== 0 && sb === 0) {
        return 1;
      }
      return Number(b?.id ?? 0) - Number(a?.id ?? 0);
    });
    return copia[0];
  }

  private obterMonitoramentosUnicosPorId(monitoramentos: any[]): any[] {
    const map = new Map<number, any>();
    for (const mon of monitoramentos || []) {
      const id = Number(mon?.id);
      if (!id || map.has(id)) {
        continue;
      }
      map.set(id, mon);
    }
    return Array.from(map.values());
  }

  private monitoramentoCobreDiaInteiro(mon: any, dia: string): boolean {
    const inicioDia = moment(dia).startOf('day');
    const fimDia = moment(dia).endOf('day');
    const inicio = moment(mon.data_hora_monitoramento);
    const fim = mon.data_hora_ultima_situacao
      ? moment(mon.data_hora_ultima_situacao)
      : moment().endOf('day');

    return inicio.isSameOrBefore(inicioDia) && fim.isSameOrAfter(fimDia);
  }

  private calcularInicioProximoMonitoramento(monitoramentos: any[], dia: string): Date | null {
    const unicos = this.obterMonitoramentosUnicosPorId(monitoramentos);
    const inicioDia = moment(dia).startOf('day');
    const fimDia = moment(dia).endOf('day');
    let ultimoFim = inicioDia.clone().subtract(1, 'minute');

    for (const mon of unicos) {
      const inicio = moment(mon.data_hora_monitoramento);
      const fim = mon.data_hora_ultima_situacao ? moment(mon.data_hora_ultima_situacao) : null;
      if (!fim || inicio.isAfter(fimDia) || fim.isBefore(inicioDia)) {
        continue;
      }

      const fimEfetivo = moment.min(fim, fimDia);
      if (fimEfetivo.isAfter(ultimoFim)) {
        ultimoFim = fimEfetivo;
      }
    }

    const proximo = ultimoFim.clone().add(1, 'minute').seconds(0).milliseconds(0);
    return proximo.isAfter(fimDia) ? null : proximo.toDate();
  }

  private diaImpossibilitaNovoMonitoramento(monitoramentos: any[], dia: string): boolean {
    const unicos = this.obterMonitoramentosUnicosPorId(monitoramentos);
    if (unicos.some((mon) => this.monitoramentoCobreDiaInteiro(mon, dia))) {
      return true;
    }
    return !this.calcularInicioProximoMonitoramento(monitoramentos, dia);
  }

  private prepararFormularioNovoMonitoramentoNoDia(dataInicio: Date): void {
    this.limparNovoMonitoramento();
    this.resetarSelecoesEventos();
    this.novoMonitoramento.data_hora_monitoramento = this.truncarSegundosData(dataInicio);
    this.novoMonitoramento.estacao_id = this.estacaoSelecionada;
    this.novoMonitoramento.monitoramento_interno = false;
    this.ajustarInicioEventosAoMonitoramento();
    this.atualizarLimitesDatasModal();
    this.modalMonitoramentoPronto = true;
  }

  private calcularDataFimAntesProximoMonitoramento(
    inicioAtual: moment.Moment,
    proximoInicio: moment.Moment
  ): Date {
    if (proximoInicio.isSame(inicioAtual, 'day')) {
      return proximoInicio.clone().subtract(1, 'minute').seconds(0).milliseconds(0).toDate();
    }

    const fimSugerido = proximoInicio.clone().subtract(1, 'day').endOf('day').seconds(0).milliseconds(0);
    if (fimSugerido.isBefore(inicioAtual)) {
      return proximoInicio.clone().subtract(1, 'minute').seconds(0).milliseconds(0).toDate();
    }

    return fimSugerido.toDate();
  }

  private deveAjustarFimPorProximoMonitoramento(): boolean {
    return !this.monitoramentoEstaFechado();
  }

  private tratarConflitoComProximoMonitoramento(resultado: any): boolean {
    if (!this.deveAjustarFimPorProximoMonitoramento()) {
      return false;
    }

    const proximoMon = resultado?.monitoramento_existente;
    if (!proximoMon?.data_hora_monitoramento) {
      return false;
    }

    const inicioAtual = this.normalizarMomentDataHora(this.novoMonitoramento.data_hora_monitoramento);
    if (!inicioAtual) {
      return false;
    }

    const proximoInicio = moment(proximoMon.data_hora_monitoramento);
    if (!proximoInicio.isAfter(inicioAtual)) {
      return false;
    }

    const novaDataFim = this.calcularDataFimAntesProximoMonitoramento(inicioAtual, proximoInicio);
    if (this.dataHoraEhAntes(novaDataFim, inicioAtual)) {
      return false;
    }

    this.novoMonitoramento.data_hora_ultima_situacao = this.truncarSegundosData(novaDataFim);
    this.atualizarLimitesDatasModal();
    this.dataFimMonitoramentoAnterior = this.truncarSegundosData(novaDataFim);

    this.messageService.add({
      severity: 'info',
      summary: 'Próximo monitoramento',
      detail: `Existe um monitoramento posterior iniciando em ${proximoInicio.format('DD/MM/YYYY HH:mm')}. A data/hora fim foi ajustada automaticamente.`
    });

    return true;
  }

  onClicarFaixaMonitoramento(col: any, rowData: any, event: Event): void {
    if (this.permissaoService.can('resumo_eventos_visualizar_eventos_monitoramentos') === false) {
      return;
    }

    event.stopPropagation();

    const faixa = this.getFaixaMonitoramentoDia(rowData, col.data_resumo);
    if (!faixa.ativo) {
      return;
    }

    const dia = moment(col.data_resumo).format('YYYY-MM-DD');
    const monId = this.obterMonitoramentoPrincipalNoDia(rowData.monitoramento || [], dia);
    if (!monId) {
      return;
    }

    this.selectDayEventosMonitoramentos(col, rowData, { monitoramentoId: monId });
  }

  private aplicarConfiguracaoEventoNoModal(eventos: any[], configuracoesEvento: any[] = []): any[] {
    if (!Array.isArray(eventos)) {
      return [];
    }

    return eventos.map((evento: any) => {
      const tipoEventoId = Number(evento?.tipo_evento_id);
      if (tipoEventoId !== 7 && tipoEventoId !== 8) {
        return evento;
      }

      const cfg = (configuracoesEvento || []).find(
        (item: any) => Number(item?.configuracao_evento_id) === tipoEventoId
      );

      if (!cfg) {
        return evento;
      }

      const quantidadeParametroDiario = Number(cfg.quantidade_parametro_diario ?? 0);
      const totalComputadoNormal = Number(
        evento?.total_computado_normal ?? evento?.total_computado ?? 0
      );
      const eventoAtualizado = {
        ...evento,
        maximo_normalidade_eventos: quantidadeParametroDiario
      };

      if (tipoEventoId === 7) {
        eventoAtualizado.disponibilidade = `${totalComputadoNormal}/${quantidadeParametroDiario}`;
        eventoAtualizado.percentual_coleta = quantidadeParametroDiario > 0
          ? `${((totalComputadoNormal / quantidadeParametroDiario) * 100).toFixed(2).replace('.', ',')} %`
          : '0,00 %';
      }

      return eventoAtualizado;
    });
  }

selectDayEventosMonitoramentos(
  col: any,
  row: any,
  opcoes?: { monitoramentoId?: number }
) {
  this.modalMonitoramentoPronto = false;
  this.modalEventosMonitoramentos = false;
  this.limparLimitesDatasModal();

  const diaCol = moment(col.data_resumo).format('YYYY-MM-DD');
  if (!opcoes?.monitoramentoId) {
    const monId = this.obterMonitoramentoPrincipalNoDia(row?.monitoramento || [], diaCol);
    if (monId) {
      opcoes = { ...(opcoes || {}), monitoramentoId: monId };
    }
  }

  this.eventosDataSelecionada.forEach(evento => {
    evento.selecionadoParaMonitoramento = false;
    evento.data_hora_inicio = null;
    evento.data_hora_fim = null;
    evento.problema = '';
    evento.desfecho = '';
  });

  this.array_monitoramento = []
      this.array_monitoramento = [
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 1,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 2,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 3,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 4,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 5,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 6,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 9,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 7,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
        {
          data_hora_monitoramento: null,
          data_hora_ultima_situacao: null,
          tipo_evento_id: 8,
          status: null,
          observacao_abertura: '',
          observacao_fechamento: '',
          desabilitar: false
        },
      ];

  this.valueDialog = [];
  this.columnsDialog = [];
  this.data_monitoramento = col.data_resumo;
  this.tituloModal = `${row.descricao} | ${col.field}`;
  this.estacaoSelecionada = row.estacao_id
  this.rowModalContext = row;

  const dataFormatada = moment(this.data_monitoramento).format('YYYY-MM-DD');

  const tipo_variavel = this.dropDownTipoVariavel.map(item => item.value);
  const params = {
    data_inicial: moment(col.data_resumo).startOf('day').format(),
    data_final: moment(col.data_resumo).endOf('day').format(),
    estacao_id: row.estacao_id,
    tipo_variavel_id: tipo_variavel,
  };

  this._variavelService.filter(params).subscribe(json => {
    this.processarDados(json);
  });

  this._resumoEventoService.mapDialog(this.estacaoSelecionada, dataFormatada).subscribe({
    next: (mapDialog: any) => {
      const eventos = (mapDialog?.eventos || []).map((evento: any) => normalizarEventoDialog({
        ...evento,
        data_resumo: dataFormatada,
        selecionadoParaMonitoramento: false,
        data_hora_inicio: null,
        data_hora_fim: null,
        problema: '',
        desfecho: '',
        monitoramento_evento_id: null,
      }));
      this.eventosDataSelecionada = this.aplicarConfiguracaoEventoNoModal(
        eventos,
        row.configuracoes_evento || []
      );
      this.carregarMonitoramentosResumoEvento(dataFormatada, row, opcoes);
    },
    error: () => {
      this.eventosDataSelecionada = this.aplicarConfiguracaoEventoNoModal(
        (row.eventos || [])
          .filter((x: any) => moment(x.data_resumo).format('YYYY-MM-DD') === diaCol)
          .map((evento: any) => normalizarEventoDialog(evento)),
        row.configuracoes_evento || []
      );
      this.carregarMonitoramentosResumoEvento(dataFormatada, row, opcoes);
    }
  });
}

private carregarMonitoramentosResumoEvento(
  dataFormatada: string,
  row: any,
  opcoes?: { monitoramentoId?: number }
): void {
  this._estacaoService.getMonitoramentos(this.estacaoSelecionada, dataFormatada).subscribe({
    next: (monitoramentos: any[]) => {
      this.monitoramentoExistente = null;
      this.novoMonitoramento = {
        id: null,
        data_hora_monitoramento: null,
        data_hora_ultima_situacao: null,
        observacao_abertura: '',
        estacao_id: null,
        status: null,
        eventos: [],
        monitoramento_interno: false
      };

      if (monitoramentos && monitoramentos.length > 0) {
        if (opcoes?.monitoramentoId) {
          const monitoramento = monitoramentos.find(
            (item: any) => Number(item.id) === Number(opcoes.monitoramentoId)
          ) || this.escolherMonitoramentoParaModal(monitoramentos);
          if (monitoramento) {
            this.aplicarMonitoramentoNoModal(monitoramento, row);
          } else {
            this.limparNovoMonitoramento();
            this.resetarSelecoesEventos();
            this.atualizarLimitesDatasModal();
            this.modalMonitoramentoPronto = true;
          }
        } else {
          const aberto = monitoramentos.find((item: any) => Number(item.status) === 0);
          const existente = aberto || this.escolherMonitoramentoParaModal(monitoramentos);
          if (existente) {
            this.aplicarMonitoramentoNoModal(existente, row);
          } else if (this.diaImpossibilitaNovoMonitoramento(monitoramentos, dataFormatada)) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Dia ocupado',
              detail: 'Este dia já possui monitoramento que ocupa todo o período. Não é possível abrir um novo monitoramento.'
            });
            this.limparNovoMonitoramento();
            this.resetarSelecoesEventos();
            this.atualizarLimitesDatasModal();
            this.modalMonitoramentoPronto = true;
          } else {
            const proximoInicio = this.calcularInicioProximoMonitoramento(monitoramentos, dataFormatada);
            if (proximoInicio) {
              this.prepararFormularioNovoMonitoramentoNoDia(proximoInicio);
            } else {
              this.messageService.add({
                severity: 'warn',
                summary: 'Dia ocupado',
                detail: 'Este dia já possui monitoramento que ocupa todo o período. Não é possível abrir um novo monitoramento.'
              });
              this.limparNovoMonitoramento();
              this.resetarSelecoesEventos();
              this.atualizarLimitesDatasModal();
              this.modalMonitoramentoPronto = true;
            }
          }
        }
      } else {
        // Não existe monitoramento no dia — verificar se há aberto na estação
        this.limparNovoMonitoramento();
        this.resetarSelecoesEventos();

        this._monitoramentoService.validarAbertura(
          this.estacaoSelecionada,
          moment(this.data_monitoramento).format('YYYY-MM-DD HH:mm:ss'),
          null
        ).subscribe({
          next: (resultado: any) => {
            if (!resultado?.pode_abrir && resultado?.motivo === 'monitoramento_aberto_existente' && resultado?.monitoramento_existente) {
              this.messageService.add({
                severity: 'info',
                summary: 'Monitoramento existente',
                detail: 'Existe um monitoramento aberto para esta estação. Carregando os dados existentes.'
              });
              this.aplicarMonitoramentoNoModal(resultado.monitoramento_existente, row);
            } else {
              this.atualizarLimitesDatasModal();
              this.modalMonitoramentoPronto = true;
            }
          },
          error: () => {
            this.atualizarLimitesDatasModal();
            this.modalMonitoramentoPronto = true;
          }
        });
      }

      // Processar dados antigos (manter compatibilidade) - se necessário
      // Os dados já foram processados acima com a nova API

      this.modalEventosMonitoramentos = true;
    },
    error: (err) => {
      console.error('Erro ao carregar monitoramentos:', err);
      this.modalMonitoramentoPronto = true;
      this.modalEventosMonitoramentos = true;
    }
  });
}


 processarDados(json: any[]) {
  const valueDialog = json.flatMap(item =>
    item.data_hora_dados.map(dataItem => {
      const groupedData = { 
        data: moment.utc(dataItem.data_hora_dado).format('DD/MM/YYYY HH:mm'),
        ...this.mapVariaveis(dataItem.variaveis)
      };
      return groupedData;
    })
  );

  this.valueDialog = valueDialog;

  if (this.valueDialog.length > 0) {
    this.columnsDialog = Object.keys(this.valueDialog[0]).map(key => ({ field: key, header: key.toUpperCase() }));
  }
}

 mapVariaveis(variaveis: any[]) {
  return variaveis.flatMap(variavelItem =>
    variavelItem.dados.map(dadoItem => ({
      [dadoItem.tipo_variavel.tipo_variavel]: dadoItem.valor
    }))
  ).reduce((acc, curr) => ({ ...acc, ...curr }), {});
}

 atualizarMonitoramentos(monitoramentos: any[], estacao_id: string) {
  monitoramentos.forEach(item => {
    const dataMonitoramento = new Date(this.data_monitoramento);
    const dataHoraMonitoramento = new Date(moment(item.data_hora_monitoramento).format('YYYY-MM-DD'));
    const dataHoraUltimaSituacao = moment(item.data_hora_ultima_situacao).isValid() ? new Date(moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD')) : null;

    const isWithinRange = dataMonitoramento >= dataHoraMonitoramento && dataMonitoramento <= dataHoraUltimaSituacao;

    if (isWithinRange) {
      const monitoramento = this.array_monitoramento.find(x => x.tipo_evento_id === item.tipo_evento_id);
      if (monitoramento) {
        monitoramento.id = item.id;
        monitoramento.data_hora_monitoramento = moment(item.data_hora_monitoramento).format('YYYY-MM-DD');
        monitoramento.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('YYYY-MM-DD');
        monitoramento.status = item.status;

        if (item.status === 2) {
          monitoramento.status = item.status;
          monitoramento.desabilitar = true;
        }
      }
    }

    console.log('this.array_monitoramento', this.array_monitoramento)
  });
}

observacao(item, event){
  this.observacoes = null
 this.dados_monitoramento = item
 this.tipo_observacao = event
 this.div_obersavacao = true
 if(event == 'abrir'){
  this.div_email = true
 } else {
  this.div_email = false
 }
}

salvar(){
   if(this.tipo_observacao == 'abrir'){
    this.abrirMonitoramento(this.dados_monitoramento)
   } else {
    this.encerrarMonitoramento(this.dados_monitoramento)
   }
}

  selectDay(col, row){
    this.valueDialog = []
    this.columnsDialog = []
    let valueDialog: any[] = []

this.tituloModal = row.descricao + ' | ' + col.field

let tipo_variavel: any[] = []
this.dropDownTipoVariavel.map(item => {
  tipo_variavel.push(item.value)
})
  
  let params = {
    data_inicial: moment(col.data_resumo).format('YYYY-MM-DDT00:00:00'),
    data_final: moment(col.data_resumo).format('YYYY-MM-DDT23:59:59'),
    estacao_id: row.estacao_id,
    tipo_variavel_id: tipo_variavel,
  }

  this._variavelService.filter(params).subscribe(json => {
    json.map(item => {
      item.data_hora_dados.map(dataItem => {
        const groupedData = { data:  moment.utc(dataItem.data_hora_dado).format('DD/MM/YYYY HH:mm')};
    
        dataItem.variaveis.map(variavelItem => {
          variavelItem.dados.map(dadoItem => {
            groupedData[dadoItem.tipo_variavel.tipo_variavel] = dadoItem.valor;
          });
        });
    
        valueDialog.push(groupedData);
      });
      this.valueDialog = valueDialog
    });
    if (this.valueDialog.length > 0) {
      this.columnsDialog = Object.keys(this.valueDialog[0]).map(key => ({ field: key, header: key.toUpperCase() }));
    }
    this.modalVariaveis = true
  })

  }

  addNovoGrupo(){
    this.modalNovoGrupo = true
   }
  
   aoSalvarNovoGrupo(): void {
    this.listGrupos()
    this.modalNovoGrupo = false;
  }

  modoMonitoramentoAtivo: boolean = false;
  novoMonitoramento: any = {
    id: null,
    data_hora_monitoramento: null,
    data_hora_ultima_situacao: null,
    observacao_abertura: '',
    estacao_id: null,
    status: null,
    eventos: [],
    monitoramento_interno: false
  };
  monitoramentoExistente: any = null;
  rowModalContext: any = null;

  minDateEvento: Date | null = null;
  maxDate: Date | null = null;
  maxDateEvento: Date | null = null;
  private dataFimMonitoramentoAnterior: Date | null = null;
  private textoInputDetached = false;

  monitoramentoFechado = false;
  monitoramentoSemDataFim = true;
  podeSalvar = false;
  podeSalvarEncerrar = false;
  podeEnviarEmailUi = false;

  trackByEventoModal(_index: number, row: any): any {
    return row?.tipo_evento_id ?? row?.monitoramento_evento_id ?? _index;
  }

  onCampoTextoFocus(): void {
    if (!this.textoInputDetached) {
      this.cdr.detach();
      this.textoInputDetached = true;
    }
  }

  onCampoTextoBlur(): void {
    if (this.textoInputDetached) {
      this.cdr.reattach();
      this.textoInputDetached = false;
      this.atualizarEstadoUiMonitoramento();
      this.cdr.detectChanges();
    }
  }

  atualizarEstadoUiMonitoramento(): void {
    this.monitoramentoFechado = this.monitoramentoEstaFechado();
    this.monitoramentoSemDataFim = !this.monitoramentoTemDataFim();
    this.podeSalvar = this.validarCamposMonitoramento();
    this.podeSalvarEncerrar = this.validarCamposMonitoramentoParaFinalizar();
    this.podeEnviarEmailUi = this.podeEnviarEmail();

    for (const evento of this.eventosDataSelecionada) {
      if (evento.selecionadoParaMonitoramento) {
        evento.minDateFim = this.getLimiteMinFimEvento(evento);
        evento.emAberto = this.eventoEstaEmAberto(evento);
        evento.iconeCss = this.getIconeEvento(evento);
      } else if (!evento.iconeCss) {
        evento.iconeCss = this.getIconeEvento(evento);
      }
    }
  }

  onSelecionarMonitoramento(evento: any, event: any): void {
  if (!evento.selecionadoParaMonitoramento) {
    this.atualizarEstadoUiMonitoramento();
    return;
  }

  if (!this.eventoTemDataInicio(evento)) {
    evento.data_hora_inicio = this.obterDataInicioPadraoEvento();
  } else if (this.dataHoraEhAntes(evento.data_hora_inicio, this.novoMonitoramento.data_hora_monitoramento)) {
    evento.data_hora_inicio = this.obterDataInicioPadraoEvento();
  }
  evento.problema = evento.problema || '';
  evento.desfecho = evento.desfecho || '';
  this.ajustarInicioEventosAoMonitoramento();
  this.atualizarEstadoUiMonitoramento();
}

private obterDataInicioPadraoEvento(): Date {
  const abertura = this.parseDataHora(this.novoMonitoramento?.data_hora_monitoramento);
  return abertura ? new Date(abertura.getTime()) : new Date();
}

limparDataFimEvento(evento: any): void {
  evento.data_hora_fim = null;
  evento.emAberto = true;
  this.atualizarEstadoUiMonitoramento();
}

limparDataFimMonitoramento(): void {
  this.novoMonitoramento.data_hora_ultima_situacao = null;
  this.onMonitoramentoDataChange();
  this.dataFimMonitoramentoAnterior = null;
}

monitoramentoTemDataFim(): boolean {
  return this.dataPreenchida(this.novoMonitoramento?.data_hora_ultima_situacao);
}

private obterDataFimMonitoramentoParaLimites(): Date | null {
  return this.parseDataHora(this.novoMonitoramento?.data_hora_ultima_situacao);
}

eventoEstaEmAberto(evento: any): boolean {
  return !this.eventoTemDataFim(evento);
}

private dataPreenchida(data: any): boolean {
  if (data === null || data === undefined || data === '') {
    return false;
  }
  if (data instanceof Date) {
    return !isNaN(data.getTime());
  }
  return moment(data).isValid();
}

eventoTemDataFim(evento: any): boolean {
  return this.dataPreenchida(evento?.data_hora_fim);
}

eventoTemDataInicio(evento: any): boolean {
  return this.dataPreenchida(evento?.data_hora_inicio);
}

parseDataHora(valor: any): Date | null {
  if (valor === null || valor === undefined || valor === '') {
    return null;
  }
  if (valor instanceof Date) {
    return isNaN(valor.getTime()) ? null : valor;
  }
  if (typeof valor === 'string') {
    const isoLocal = valor.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})/);
    if (isoLocal) {
      const parsedIsoLocal = moment(isoLocal[1], 'YYYY-MM-DDTHH:mm:ss', true);
      if (parsedIsoLocal.isValid()) {
        return parsedIsoLocal.toDate();
      }
    }

    const formatos = [
      moment.ISO_8601,
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm',
      'DD/MM/YYYY HH:mm:ss',
      'DD/MM/YYYY HH:mm',
    ];
    const parsedComFormato = moment(valor, formatos, true);
    if (parsedComFormato.isValid()) {
      return parsedComFormato.toDate();
    }
  }
  const parsed = moment(valor);
  return parsed.isValid() ? parsed.toDate() : null;
}

private truncarSegundosData(valor: any): Date | null {
  const data = this.parseDataHora(valor);
  return data ? moment(data).seconds(0).milliseconds(0).toDate() : null;
}

private resolverDataHoraEvento(valorEvento: any, valorMonitoramento: any): Date | null {
  const monRef = this.parseDataHora(valorMonitoramento)
    ?? this.parseDataHora(this.novoMonitoramento?.data_hora_monitoramento);
  const evRef = this.parseDataHora(valorEvento);

  if (!evRef && !monRef) {
    return null;
  }
  if (!evRef) {
    return this.truncarSegundosData(monRef);
  }
  if (!monRef) {
    return this.truncarSegundosData(evRef);
  }

  const ev = moment(evRef).seconds(0).milliseconds(0);
  const mon = moment(monRef).seconds(0).milliseconds(0);
  if (ev.isBefore(mon)) {
    return this.truncarSegundosData(monRef);
  }
  return this.truncarSegundosData(evRef);
}

private normalizarMomentDataHora(valor: any): moment.Moment | null {
  const data = this.parseDataHora(valor);
  return data ? moment(data).seconds(0).milliseconds(0) : null;
}

private dataHoraEhAntes(valorA: any, valorB: any): boolean {
  const a = this.normalizarMomentDataHora(valorA);
  const b = this.normalizarMomentDataHora(valorB);
  if (!a || !b) {
    return false;
  }
  return a.isBefore(b);
}

private dataHoraEhDepois(valorA: any, valorB: any): boolean {
  const a = this.normalizarMomentDataHora(valorA);
  const b = this.normalizarMomentDataHora(valorB);
  if (!a || !b) {
    return false;
  }
  return a.isAfter(b);
}

private ajustarInicioEventosAoMonitoramento(): void {
  const monInicio = this.normalizarMomentDataHora(this.novoMonitoramento?.data_hora_monitoramento);
  if (!monInicio) {
    return;
  }

  const monFim = this.normalizarMomentDataHora(this.novoMonitoramento?.data_hora_ultima_situacao);

  for (const evento of this.eventosDataSelecionada) {
    if (!evento.selecionadoParaMonitoramento) {
      continue;
    }

    let evInicio = this.normalizarMomentDataHora(evento.data_hora_inicio);
    if (!evInicio || evInicio.isBefore(monInicio)) {
      evento.data_hora_inicio = this.truncarSegundosData(this.novoMonitoramento?.data_hora_monitoramento);
      continue;
    }
    if (monFim && evInicio.isAfter(monFim)) {
      evento.data_hora_inicio = this.truncarSegundosData(this.novoMonitoramento?.data_hora_ultima_situacao);
      continue;
    }
    evento.data_hora_inicio = this.truncarSegundosData(evento.data_hora_inicio);
  }
}

private ajustarFimEventosAoMonitoramento(dataAnterior: Date | null = null): void {
  const monFim = this.truncarSegundosData(this.novoMonitoramento?.data_hora_ultima_situacao);
  if (!monFim) {
    return;
  }

  const eventosComConflito: any[] = [];

  for (const evento of this.eventosDataSelecionada) {
    if (!evento.selecionadoParaMonitoramento) {
      continue;
    }

    if (!this.eventoTemDataFim(evento)) {
      evento.data_hora_fim = new Date(monFim.getTime());
      continue;
    }

    if (this.dataHoraEhDepois(evento.data_hora_fim, monFim)) {
      eventosComConflito.push(evento);
    }
  }

  if (eventosComConflito.length === 0) {
    return;
  }

  const monFimFormatado = moment(monFim).format('DD/MM/YYYY HH:mm');
  const descricoes = eventosComConflito
    .map(e => {
      const evFim = moment(e.data_hora_fim).format('DD/MM/YYYY HH:mm');
      return `"${e.tipo_evento?.descricao}" (${evFim})`;
    })
    .join(', ');

  this.confirmationService.confirm({
    key: 'globalConfirm',
    message: `A data/hora fim do monitoramento (${monFimFormatado}) é anterior à data/hora fim de um ou mais eventos marcados: ${descricoes}. Deseja ajustar a data/hora fim desses eventos para a data/hora fim do monitoramento?`,
    header: 'Conflito de datas',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sim',
    rejectLabel: 'Não',
    accept: () => {
      for (const evento of eventosComConflito) {
        evento.data_hora_fim = new Date(monFim.getTime());
      }
    },
    reject: () => {
      this.novoMonitoramento.data_hora_ultima_situacao = dataAnterior
        ? new Date(dataAnterior.getTime())
        : null;
      this.dataFimMonitoramentoAnterior = dataAnterior
        ? new Date(dataAnterior.getTime())
        : null;
      this.atualizarLimitesDatasModal();
      this.ajustarInicioEventosAoMonitoramento();
    }
  });
}

private limparLimitesDatasModal(): void {
  this.minDateEvento = null;
  this.maxDate = null;
  this.maxDateEvento = null;
  this.dataFimMonitoramentoAnterior = null;
}

private atualizarLimitesDatasModal(): void {
  const inicioMon = this.parseDataHora(this.novoMonitoramento?.data_hora_monitoramento);
  const fimMon = this.obterDataFimMonitoramentoParaLimites();
  const hojeFim = moment().endOf('day').toDate();

  this.minDateEvento = this.truncarSegundosData(inicioMon);

  if (fimMon) {
    this.maxDateEvento = new Date(fimMon.getTime());
    this.maxDate = moment(fimMon).endOf('day').toDate();
  } else {
    this.maxDateEvento = hojeFim;
    this.maxDate = hojeFim;
  }

  if (this.minDateEvento && this.maxDateEvento && this.minDateEvento.getTime() > this.maxDateEvento.getTime()) {
    this.maxDateEvento = moment.max(moment(this.minDateEvento), moment()).endOf('day').toDate();
    this.maxDate = this.maxDateEvento;
  }

  this.atualizarEstadoUiMonitoramento();
}

getLimiteMinInicioEvento(evento: any): Date | null {
  return this.minDateEvento;
}

getLimiteMaxDataEvento(): Date | null {
  return this.maxDateEvento;
}

getLimiteMinFimEvento(evento: any): Date | null {
  const candidatos: moment.Moment[] = [];
  const evInicio = this.parseDataHora(evento?.data_hora_inicio);
  const monInicio = this.parseDataHora(this.novoMonitoramento?.data_hora_monitoramento);

  if (evInicio) {
    candidatos.push(moment(evInicio));
  }
  if (monInicio) {
    candidatos.push(moment(monInicio));
  }

  return candidatos.length ? moment.min(candidatos).toDate() : null;
}

private recarregarMonitoramentoNoModal(): void {
  if (!this.novoMonitoramento.id || !this.estacaoSelecionada || !this.data_monitoramento) {
    return;
  }

  const dataFormatada = moment(this.data_monitoramento).format('YYYY-MM-DD');
  this._estacaoService.getMonitoramentos(this.estacaoSelecionada, dataFormatada).subscribe({
    next: (monitoramentos: any[]) => {
      if (!monitoramentos?.length) {
        return;
      }

      const monitoramento = monitoramentos.find(
        (item: any) => Number(item.id) === Number(this.novoMonitoramento.id)
      ) || this.escolherMonitoramentoParaModal(monitoramentos);

      if (monitoramento) {
        this.aplicarMonitoramentoNoModal(monitoramento, this.rowModalContext);
      }
    }
  });
}

temEventosSelecionados(): boolean {
  return this.eventosDataSelecionada.some(evento => evento.selecionadoParaMonitoramento);
}

ativarModoMonitoramento(): void {
  this.modoMonitoramentoAtivo = true;
  
  // Inicializar datas do monitoramento
  const agora = new Date();
  this.novoMonitoramento.data_hora_monitoramento = agora;
  
  // Não definir data_hora_ultima_situacao por padrão - só será obrigatória ao finalizar
  this.novoMonitoramento.data_hora_ultima_situacao = null;
  
  this.novoMonitoramento.estacao_id = this.estacaoSelecionada;
  this.novoMonitoramento.observacao_abertura = '';
  this.novoMonitoramento.monitoramento_interno = false;
}

cancelarMonitoramento(): void {
  if (this.textoInputDetached) {
    this.cdr.reattach();
    this.textoInputDetached = false;
  }
  this.modoMonitoramentoAtivo = false;
  this.limparNovoMonitoramento();
}

limparNovoMonitoramento(): void {
  this.novoMonitoramento = {
    id: null,
    data_hora_monitoramento: null,
    data_hora_ultima_situacao: null,
    observacao_abertura: '',
    estacao_id: null,
    status: null,
    eventos: [],
    monitoramento_interno: false
  };
  this.monitoramentoExistente = null;
  this.atualizarEstadoUiMonitoramento();
}

validarCamposMonitoramento(): boolean {
  // Apenas data_hora_monitoramento é obrigatória
  // data_hora_ultima_situacao só é obrigatória ao finalizar (tipo === 'encerrar')
  return !!this.novoMonitoramento.data_hora_monitoramento;
}

monitoramentoEstaFechado(): boolean {
  const status = this.novoMonitoramento?.status ?? this.monitoramentoExistente?.status;
  return status !== null && status !== undefined && Number(status) !== 0;
}

validarEventosDentroDoMonitoramento(): { valido: boolean; mensagem?: string } {
  const monInicio = this.normalizarMomentDataHora(this.novoMonitoramento.data_hora_monitoramento);
  const monFim = this.normalizarMomentDataHora(this.novoMonitoramento.data_hora_ultima_situacao);

  if (!monInicio) {
    return { valido: false, mensagem: 'Preencha a data/hora de início do monitoramento' };
  }

  if (monFim && this.dataHoraEhAntes(this.novoMonitoramento.data_hora_ultima_situacao, monInicio)) {
    return { valido: false, mensagem: 'A data/hora fim do monitoramento deve ser posterior ao início' };
  }

  const eventosMarcados = this.eventosDataSelecionada.filter(e => e.selecionadoParaMonitoramento);

  for (const evento of eventosMarcados) {
    if (evento.data_hora_inicio && this.dataHoraEhAntes(evento.data_hora_inicio, monInicio)) {
      return { valido: false, mensagem: `A data/hora início do evento "${evento.tipo_evento?.descricao}" deve estar dentro do intervalo do monitoramento` };
    }
    if (monFim && evento.data_hora_fim && this.dataHoraEhDepois(evento.data_hora_fim, monFim)) {
      return { valido: false, mensagem: `A data/hora fim do evento "${evento.tipo_evento?.descricao}" deve estar dentro do intervalo do monitoramento` };
    }
    if (evento.data_hora_inicio && evento.data_hora_fim && this.dataHoraEhAntes(evento.data_hora_fim, evento.data_hora_inicio)) {
      return { valido: false, mensagem: `A data/hora fim do evento "${evento.tipo_evento?.descricao}" deve ser posterior ao início` };
    }
  }

  return { valido: true };
}

validarEventosParaEncerrar(): boolean {
  return this.eventosDataSelecionada
    .filter(e => e.selecionadoParaMonitoramento)
    .every(e => this.eventoTemDataFim(e));
}

podeEnviarEmail(): boolean {
  if (this.loadingEnviarEmail) {
    return false;
  }
  // Permite reenvio mesmo com monitoramento fechado, se estiver editando um existente
  if (this.novoMonitoramento?.id) {
    return true;
  }
  if (this.temMonitoramentoAtivo()) {
    return true;
  }
  return this.validarCamposMonitoramento() && this.temEventosSelecionados();
}

onMonitoramentoDataChange(): void {
  this.atualizarLimitesDatasModal();
  this.ajustarInicioEventosAoMonitoramento();

  if (!this.novoMonitoramento.data_hora_monitoramento || !this.estacaoSelecionada) {
    return;
  }
  if (this.monitoramentoEstaFechado()) {
    return;
  }

  const dataInicio = moment(this.novoMonitoramento.data_hora_monitoramento).format('YYYY-MM-DD HH:mm:ss');
  const dataFim = this.novoMonitoramento.data_hora_ultima_situacao
    ? moment(this.novoMonitoramento.data_hora_ultima_situacao).format('YYYY-MM-DD HH:mm:ss')
    : null;

  this._monitoramentoService.validarAbertura(
    this.estacaoSelecionada,
    dataInicio,
    dataFim,
    this.novoMonitoramento.id
  ).subscribe({
    next: (resultado: any) => {
      if (!resultado?.pode_abrir && resultado?.motivo === 'monitoramento_aberto_existente' && resultado?.monitoramento_existente) {
        this.modalMonitoramentoPronto = false;
        this.messageService.add({
          severity: 'info',
          summary: 'Monitoramento existente',
          detail: 'Já existe um monitoramento aberto para esta estação. Carregando os dados existentes.'
        });
        this.aplicarMonitoramentoNoModal(resultado.monitoramento_existente, this.rowModalContext);
      } else if (!resultado?.pode_abrir && resultado?.motivo === 'conflito_fechado') {
        if (!this.tratarConflitoComProximoMonitoramento(resultado)) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Conflito de intervalo',
            detail: 'O intervalo informado conflita com um monitoramento fechado existente para esta estação.'
          });
        }
      }
    }
  });
}

onMonitoramentoFimDataChange(): void {
  const dataAnterior = this.dataFimMonitoramentoAnterior;
  this.onMonitoramentoDataChange();
  this.ajustarFimEventosAoMonitoramento(dataAnterior);
  this.dataFimMonitoramentoAnterior = this.truncarSegundosData(this.novoMonitoramento?.data_hora_ultima_situacao);
}

private aplicarMonitoramentoNoModal(monitoramento: any, row: any): void {
  const diaCol = moment(this.data_monitoramento).format('YYYY-MM-DD');

  this.monitoramentoExistente = monitoramento;
  this.novoMonitoramento.id = monitoramento.id;
  this.novoMonitoramento.status = monitoramento.status;
  this.novoMonitoramento.data_hora_monitoramento = this.truncarSegundosData(monitoramento.data_hora_monitoramento);
  this.novoMonitoramento.data_hora_ultima_situacao = Number(monitoramento.status) === 0
    ? null
    : this.parseDataHora(monitoramento.data_hora_ultima_situacao);
  this.novoMonitoramento.observacao_abertura = monitoramento.observacao_abertura || '';
  this.novoMonitoramento.estacao_id = monitoramento.estacao_id;
  this.novoMonitoramento.monitoramento_interno = monitoramento.monitoramento_interno || false;

  this.eventosDataSelecionada.forEach(evento => {
    evento.selecionadoParaMonitoramento = false;
    evento.data_hora_inicio = null;
    evento.data_hora_fim = null;
    evento.problema = '';
    evento.desfecho = '';
    evento.monitoramento_evento_id = null;
  });

  if (monitoramento.eventos && monitoramento.eventos.length > 0) {
    monitoramento.eventos.forEach((eventoMonitoramento: any) => {
      const tipoId = Number(eventoMonitoramento.tipo_evento_id);
      const evento = this.eventosDataSelecionada.find(
        (e: any) => Number(e.tipo_evento_id) === tipoId
      );

      if (evento) {
        evento.selecionadoParaMonitoramento = true;
        evento.data_hora_inicio = this.resolverDataHoraEvento(
          eventoMonitoramento.data_hora_inicio,
          monitoramento.data_hora_monitoramento
        );
        evento.data_hora_fim = this.parseDataHora(eventoMonitoramento.data_hora_fim);
        evento.problema = eventoMonitoramento.problema || '';
        evento.desfecho = eventoMonitoramento.desfecho || '';
        evento.monitoramento_evento_id = eventoMonitoramento.id;
      } else if (eventoMonitoramento.tipo_evento || eventoMonitoramento.tipo_evento_descricao) {
        const configs = row?.configuracoes_evento || [];
        const cfg = configs.find((c: any) => Number(c.configuracao_evento_id) === tipoId);
        const tipoEvento = eventoMonitoramento.tipo_evento || {
          descricao: eventoMonitoramento.tipo_evento_descricao,
          icone: eventoMonitoramento.tipo_evento_icone,
        };
        if (this.eventosDataSelecionada.some((e: any) => Number(e.tipo_evento_id) === tipoId)) {
          return;
        }
        const novoEvento: any = {
          data_resumo: diaCol,
          tipo_evento_id: tipoId,
          tipo_evento: tipoEvento,
          maximo_normalidade_eventos: cfg?.quantidade_parametro_diario ?? 0,
          total_computado: 0,
          situaca_evento: 0,
          tooltip: '',
          cor: '#6c8f3f',
          selecionadoParaMonitoramento: true,
          data_hora_inicio: this.resolverDataHoraEvento(
            eventoMonitoramento.data_hora_inicio,
            monitoramento.data_hora_monitoramento
          ),
          data_hora_fim: this.parseDataHora(eventoMonitoramento.data_hora_fim),
          problema: eventoMonitoramento.problema || '',
          desfecho: eventoMonitoramento.desfecho || '',
          monitoramento_evento_id: eventoMonitoramento.id,
          disponibilidade: null,
          percentual_coleta: null,
          percentual_integracao: null,
          atraso_medio_integracao: null
        };
        this.eventosDataSelecionada.push(novoEvento);
      }
    });
    this.eventosDataSelecionada.sort(
      (a: any, b: any) => Number(a.tipo_evento_id) - Number(b.tipo_evento_id)
    );
  }

  this.ajustarInicioEventosAoMonitoramento();
  this.atualizarLimitesDatasModal();
  this.dataFimMonitoramentoAnterior = this.truncarSegundosData(this.novoMonitoramento?.data_hora_ultima_situacao);
  this.modalMonitoramentoPronto = true;
  this.atualizarEstadoUiMonitoramento();
}

private validarAberturaAntesSalvar(tipo: 'abrir' | 'encerrar'): Promise<boolean> {
  return new Promise((resolve) => {
    if (!this.novoMonitoramento.data_hora_monitoramento || !this.estacaoSelecionada) {
      resolve(true);
      return;
    }

    const dataInicio = moment(this.novoMonitoramento.data_hora_monitoramento).format('YYYY-MM-DD HH:mm:ss');
    const dataFim = this.novoMonitoramento.data_hora_ultima_situacao
      ? moment(this.novoMonitoramento.data_hora_ultima_situacao).format('YYYY-MM-DD HH:mm:ss')
      : (tipo === 'encerrar' ? dataInicio : moment().format('YYYY-MM-DD HH:mm:ss'));

    this._monitoramentoService.validarAbertura(
      this.estacaoSelecionada,
      dataInicio,
      dataFim,
      this.novoMonitoramento.id
    ).subscribe({
      next: (resultado: any) => {
        if (!resultado?.pode_abrir && resultado?.motivo === 'monitoramento_aberto_existente' && resultado?.monitoramento_existente) {
          this.modalMonitoramentoPronto = false;
          this.messageService.add({
            severity: 'warn',
            summary: 'Monitoramento aberto',
            detail: 'Já existe um monitoramento aberto para esta estação. Carregando os dados existentes.'
          });
          this.aplicarMonitoramentoNoModal(resultado.monitoramento_existente, this.rowModalContext);
          resolve(false);
          return;
        }
        if (!resultado?.pode_abrir && resultado?.motivo === 'conflito_fechado') {
          if (this.tratarConflitoComProximoMonitoramento(resultado)) {
            resolve(true);
            return;
          }
          this.messageService.add({
            severity: 'error',
            summary: 'Conflito de intervalo',
            detail: 'O intervalo informado conflita com um monitoramento fechado existente para esta estação.'
          });
          resolve(false);
          return;
        }
        resolve(true);
      },
      error: () => resolve(true)
    });
  });
}

validarCamposMonitoramentoParaFinalizar(): boolean {
  // Validação específica para finalizar - exige data_hora_ultima_situacao
  return !!this.novoMonitoramento.data_hora_monitoramento && 
         !!this.novoMonitoramento.data_hora_ultima_situacao;
}

temMonitoramentoAtivo(): boolean {
  // Verifica se há monitoramento existente e ativo (status === 0) para a estação selecionada
  if (!this.estacaoSelecionada) {
    return false;
  }
  
  // Verifica se há monitoramento existente com status ativo (0 = em monitoramento)
  if (this.monitoramentoExistente && this.monitoramentoExistente.status === 0) {
    return true;
  }
  
  // Verifica se o novo monitoramento tem ID e status ativo
  if (this.novoMonitoramento.id && this.novoMonitoramento.status === 0) {
    return true;
  }
  
  return false;
}

enviarEmailEstacao(): void {
  if (this.textoInputDetached) {
    this.cdr.reattach();
    this.textoInputDetached = false;
    this.atualizarEstadoUiMonitoramento();
  }

  if (!this.estacaoSelecionada) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Selecione uma estação para enviar o e-mail'
    });
    return;
  }

  const temDadosValidos = this.validarCamposMonitoramento() && 
                         this.eventosDataSelecionada.some(e => e.selecionadoParaMonitoramento);
  // Persiste alterações antes do envio quando aberto; fechado só reenvia o e-mail
  const precisaSalvar = temDadosValidos && !this.monitoramentoEstaFechado();
  const temMonitoramentoSalvo = !!this.novoMonitoramento?.id;

  if (precisaSalvar && !this.validarCamposMonitoramento()) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Preencha todas as datas obrigatórias do monitoramento antes de enviar o e-mail'
    });
    return;
  }

  if (precisaSalvar && !this.eventosDataSelecionada.some(e => e.selecionadoParaMonitoramento)) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Selecione pelo menos um evento antes de enviar o e-mail'
    });
    return;
  }

  // Se não precisa salvar e não tem monitoramento (aberto ou fechado), não pode enviar
  if (!precisaSalvar && !this.temMonitoramentoAtivo() && !temMonitoramentoSalvo) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Não há monitoramento ativo para esta estação'
    });
    return;
  }

  const estacaoSelecionada = this.dropDownEstacao.find(e => e.value === this.estacaoSelecionada);
  const nomeEstacao = estacaoSelecionada ? estacaoSelecionada.label : `ID: ${this.estacaoSelecionada}`;

  this.confirmationService.confirm({
    key: 'globalConfirm',
    message:
      `Deseja realmente enviar e-mail de monitoramento para a estação "${nomeEstacao}"?<br>` +
      `O e-mail será enviado para todos os grupos de e-mail relacionados a esta estação.`,
    header: 'Confirmar Envio de E-mail',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sim',
    rejectLabel: 'Não',
    accept: () => {
      this.loadingEnviarEmail = true;
      
      if (precisaSalvar) {
        this.salvarMonitoramentoEEnviarEmail();
      } else {
        this.executarEnvioEmail();
      }
    },
    reject: () => {
      // Modal fecha automaticamente ao clicar em "Não"
    }
  });
}

salvarMonitoramentoEEnviarEmail(): void {
  const validacaoEventos = this.validarEventosDentroDoMonitoramento();
  if (!validacaoEventos.valido) {
    this.loadingEnviarEmail = false;
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: validacaoEventos.mensagem
    });
    return;
  }

  const eventosSelecionados = this.montarEventosSelecionados('abrir');
  if (eventosSelecionados.length === 0) {
    this.loadingEnviarEmail = false;
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: 'Selecione pelo menos um evento antes de enviar o e-mail'
    });
    return;
  }

  this.validarAberturaAntesSalvar('abrir').then((podeSalvar) => {
    if (!podeSalvar) {
      this.loadingEnviarEmail = false;
      return;
    }
    this.persistirMonitoramento('abrir', eventosSelecionados, () => {
      this.executarEnvioEmail();
    });
  });
}

executarEnvioEmail(): void {
  this._monitoramentoService.enviarEmailEstacao(
    this.estacaoSelecionada,
    null,
    this.novoMonitoramento?.id ?? null
  ).subscribe({
    next: (resultado: any) => {
      this.loadingEnviarEmail = false;
      
      if (resultado.sucesso) {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `${resultado.mensagem || 'E-mail enviado com sucesso'}. Grupos encontrados: ${resultado.grupos_encontrados || 0}, E-mails enviados: ${resultado.emails_enviados || 0}${resultado.emails_com_erro > 0 ? `, E-mails com erro: ${resultado.emails_com_erro}` : ''}`
        });
      } else {
        this.messageService.add({
          severity: 'info',
          summary: 'Informação',
          detail: resultado.mensagem || 'Nenhum grupo de e-mail encontrado para esta estação. Verifique o cadastro em Monitoramento > Grupos de E-mail.'
        });
      }

      this.atualizarLinhaEstacaoAposSalvar();
    },
    error: (err) => {
      this.loadingEnviarEmail = false;
      const errorMsg = err?.error?.message || 'Erro ao enviar e-mail';
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: errorMsg
      });
    }
  });
}

salvarMonitoramento(tipo: 'abrir' | 'encerrar'): void {
  if (tipo === 'encerrar') {
    if (!this.validarCamposMonitoramentoParaFinalizar()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Preencha todas as datas obrigatórias para finalizar o monitoramento'
      });
      return;
    }
    if (!this.validarEventosParaEncerrar()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Todos os eventos marcados devem ter data/hora de encerramento para finalizar o monitoramento'
      });
      return;
    }
  } else {
    if (!this.validarCamposMonitoramento()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Preencha a data/hora de início do monitoramento'
      });
      return;
    }
  }

  this.ajustarInicioEventosAoMonitoramento();
  const validacaoEventos = this.validarEventosDentroDoMonitoramento();
  if (!validacaoEventos.valido) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: validacaoEventos.mensagem
    });
    return;
  }

  const eventosSelecionados = this.montarEventosSelecionados(tipo);
  if (eventosSelecionados.length === 0) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: 'Selecione pelo menos um evento'
    });
    return;
  }

  this.validarAberturaAntesSalvar(tipo).then((podeSalvar) => {
    if (!podeSalvar) {
      return;
    }
    this.persistirMonitoramento(tipo, eventosSelecionados);
  });
}

private montarEventosSelecionados(tipo: 'abrir' | 'encerrar'): any[] {
  return this.eventosDataSelecionada
    .filter(evento => evento.selecionadoParaMonitoramento)
    .map(evento => ({
      id: evento.monitoramento_evento_id || null,
      tipo_evento_id: evento.tipo_evento_id,
      data_hora_inicio: this.eventoTemDataInicio(evento)
        ? moment(evento.data_hora_inicio).format('YYYY-MM-DD HH:mm:ss')
        : null,
      data_hora_fim: this.eventoTemDataFim(evento)
        ? moment(evento.data_hora_fim).format('YYYY-MM-DD HH:mm:ss')
        : null,
      problema: (evento.problema ?? '').toString().trim(),
      desfecho: (evento.desfecho ?? '').toString().trim(),
      status: tipo === 'abrir' ? 0 : 1
    }));
}

private persistirMonitoramento(tipo: 'abrir' | 'encerrar', eventosSelecionados: any[], callback?: () => void): void {
  const existeMonitoramento = this.novoMonitoramento.id !== null && this.novoMonitoramento.id !== undefined;

  if (existeMonitoramento) {
    const payloadAtualizacao: any = {
      status: tipo === 'abrir' ? 0 : 1,
      observacao_abertura: this.novoMonitoramento.observacao_abertura,
      observacao_fechamento: tipo === 'encerrar' ? (this.novoMonitoramento.observacao_fechamento || '') : null,
      monitoramento_interno: this.novoMonitoramento.monitoramento_interno || false,
      eventos: eventosSelecionados
    };

    if (this.novoMonitoramento.data_hora_monitoramento) {
      payloadAtualizacao.data_hora_monitoramento = moment(this.novoMonitoramento.data_hora_monitoramento).format('YYYY-MM-DD HH:mm:ss');
    }

    if (this.novoMonitoramento.data_hora_ultima_situacao) {
      payloadAtualizacao.data_hora_ultima_situacao = moment(this.novoMonitoramento.data_hora_ultima_situacao).format('YYYY-MM-DD HH:mm:ss');
    }

    this._monitoramentoService.atualizar(this.novoMonitoramento.id, payloadAtualizacao).subscribe({
      next: () => {
        this.novoMonitoramento.status = tipo === 'abrir' ? 0 : 1;
        if (this.monitoramentoExistente) {
          this.monitoramentoExistente.status = tipo === 'abrir' ? 0 : 1;
        }
        this.finalizarAtualizacao(tipo, eventosSelecionados.length, 0, callback);
      },
      error: () => {
        if (callback) {
          this.loadingEnviarEmail = false;
        }
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível atualizar o monitoramento'
        });
      }
    });
    return;
  }

  const payload: any = {
    estacao_id: this.estacaoSelecionada,
    status: tipo === 'abrir' ? 0 : 1,
    data_hora_monitoramento: moment(this.novoMonitoramento.data_hora_monitoramento).format('YYYY-MM-DD HH:mm:ss'),
    observacao_abertura: this.novoMonitoramento.observacao_abertura,
    monitoramento_interno: this.novoMonitoramento.monitoramento_interno || false,
    eventos: eventosSelecionados.map(e => ({
      tipo_evento_id: e.tipo_evento_id,
      data_hora_inicio: e.data_hora_inicio,
      data_hora_fim: e.data_hora_fim,
      status: e.status,
      problema: e.problema,
      desfecho: e.desfecho
    }))
  };

  if (this.novoMonitoramento.data_hora_ultima_situacao) {
    payload.data_hora_ultima_situacao = moment(this.novoMonitoramento.data_hora_ultima_situacao).format('YYYY-MM-DD HH:mm:ss');
  }

  this._monitoramentoService.criarEmLote(payload).subscribe({
    next: (response) => {
      if (response?.id) {
        this.novoMonitoramento.id = response.id;
        this.novoMonitoramento.status = tipo === 'abrir' ? 0 : 1;
        this.monitoramentoExistente = { ...this.novoMonitoramento };
        this.sincronizarIdsEventosAposCriacao(response);
        if (tipo === 'abrir' && this.rowModalContext) {
          this.aplicarMonitoramentoNoModal(response, this.rowModalContext);
        }
      }

      if (callback) {
        callback();
        return;
      }

      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: `Monitoramento ${tipo === 'abrir' ? 'salvo' : 'encerrado'} com ${eventosSelecionados.length} evento(s)`
      });

      if (tipo === 'encerrar') {
        this.finalizarEncerramentoNaUi();
      } else {
        this.modalEventosMonitoramentos = false;
        this.atualizarLinhaEstacaoAposSalvar();
      }
    },
    error: () => {
      if (callback) {
        this.loadingEnviarEmail = false;
      }
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Não foi possível criar o monitoramento'
      });
    }
  });
}

private sincronizarIdsEventosAposCriacao(response: any): void {
  const eventosResposta = response?.eventos || [];
  eventosResposta.forEach((eventoSalvo: any) => {
    const eventoLocal = this.eventosDataSelecionada.find(
      (e: any) => Number(e.tipo_evento_id) === Number(eventoSalvo.tipo_evento_id)
    );
    if (eventoLocal) {
      eventoLocal.monitoramento_evento_id = eventoSalvo.id;
    }
  });
}

atualizarEventosMonitoramento(eventos: any[], tipo: 'abrir' | 'encerrar', callback?: () => void): void {
  let eventosAtualizados = 0;
  let eventosComErro = 0;
  const totalOperacoes = eventos.length;

  const verificarFim = (): void => {
    if (eventosAtualizados + eventosComErro === totalOperacoes) {
      this.finalizarAtualizacao(tipo, eventosAtualizados, eventosComErro, callback);
    }
  };

  if (totalOperacoes === 0) {
    this.finalizarAtualizacao(tipo, 0, 0, callback);
    return;
  }

  eventos.forEach((evento) => {
    if (evento.id) {
      const payloadEvento = {
        data_hora_inicio: evento.data_hora_inicio,
        data_hora_fim: evento.data_hora_fim,
        status: evento.status,
        problema: evento.problema,
        desfecho: evento.desfecho
      };

      this._monitoramentoService.atualizarEvento(evento.id, payloadEvento).subscribe({
        next: () => {
          eventosAtualizados++;
          verificarFim();
        },
        error: (error) => {
          console.error('Erro ao atualizar evento:', error);
          eventosComErro++;
          verificarFim();
        }
      });
    } else {
      const payloadNovoEvento = {
        monitoramento_id: this.novoMonitoramento.id,
        tipo_evento_id: evento.tipo_evento_id,
        data_hora_inicio: evento.data_hora_inicio,
        data_hora_fim: evento.data_hora_fim,
        status: evento.status,
        problema: evento.problema,
        desfecho: evento.desfecho
      };

      this._monitoramentoService.criarEvento(payloadNovoEvento).subscribe({
        next: (response: any) => {
          const eventoLocal = this.eventosDataSelecionada.find(
            (e: any) => Number(e.tipo_evento_id) === Number(evento.tipo_evento_id)
          );
          if (eventoLocal && response?.id) {
            eventoLocal.monitoramento_evento_id = response.id;
          }
          eventosAtualizados++;
          verificarFim();
        },
        error: (error) => {
          console.error('Erro ao criar evento:', error);
          eventosComErro++;
          verificarFim();
        }
      });
    }
  });
}

finalizarAtualizacao(tipo: 'abrir' | 'encerrar', eventosAtualizados: number, eventosComErro: number, callback?: () => void): void {
  if (callback) {
    callback();
    return;
  }

  if (eventosComErro === 0) {
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: `Monitoramento ${tipo === 'abrir' ? 'atualizado' : 'encerrado'} com ${eventosAtualizados} evento(s)`
    });
  } else {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: `Monitoramento atualizado, mas ${eventosComErro} evento(s) apresentaram erro`
    });
  }

  if (tipo === 'encerrar') {
    this.finalizarEncerramentoNaUi();
  } else if (eventosComErro === 0) {
    this.modalEventosMonitoramentos = false;
    this.atualizarLinhaEstacaoAposSalvar();
  } else {
    this.atualizarLinhaEstacaoAposSalvar();
  }
}

private finalizarEncerramentoNaUi(): void {
  const dataInicioRefresh = this.obterDataInicioAtualizacaoParcial();
  this.modoMonitoramentoAtivo = false;
  this.limparNovoMonitoramento();
  this.resetarSelecoesEventos();
  this.modalEventosMonitoramentos = false;
  this.atualizarLinhaEstacaoAposSalvar(undefined, dataInicioRefresh);
}

resetarSelecoesEventos(): void {
  this.eventosDataSelecionada.forEach(evento => {
    evento.selecionadoParaMonitoramento = false;
    evento.data_hora_inicio = null;
    evento.data_hora_fim = null;
    evento.problema = '';
    evento.desfecho = '';
  });
}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
      this.limitarScrollVerticalGrid();
    }, 200);
  }

  get totalEstacoesApi(): number {
    return this.data?.length ?? 0;
  }

  get totalEstacoesExibidas(): number {
    return this.dataGridExibida?.length ?? 0;
  }

  get totalizadorEstacoesDiverge(): boolean {
    return this.totalEstacoesApi !== this.totalEstacoesExibidas;
  }

  get virtualRowHeight(): number {
    return this.versao === '1'
      ? this.VIRTUAL_ROW_HEIGHT_COMPLETO
      : this.VIRTUAL_ROW_HEIGHT_SIMPLIFICADO;
  }

  ngOnDestroy(): void {
    this.filtroSub?.unsubscribe();
    // Esconde a legenda no footer quando sair do componente
    this.layoutService.state.footerLegendVisible = false;
  }

  calculateScrollHeight(): void {
    if (!this.tableWrapper?.nativeElement) {
      setTimeout(() => this.calculateScrollHeight(), 100);
      return;
    }

    const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
    if (wrapperHeight === 0) {
      setTimeout(() => this.calculateScrollHeight(), 100);
      return;
    }

    this.scrollHeightBasePx = Math.max(wrapperHeight - 5, 400);
    this.scrollHeight = `${this.scrollHeightBasePx}px`;
    this.alturaVirtualScrollerAntesPreview = null;
  }

  private obterAlturaVirtualScrollerPx(element: HTMLElement): number {
    const inlineHeight = parseFloat(element.style.height);
    if (!Number.isNaN(inlineHeight) && inlineHeight > 0) {
      return inlineHeight;
    }

    return element.offsetHeight;
  }

  private ajustarAlturaVirtualScrollerPreview(): void {
    setTimeout(() => {
      const scrollBody = this.getTableScrollBody();
      if (!scrollBody) {
        return;
      }

      if (this.versao === '0' && this.linhaPreviewCompletaEstacaoId != null) {
        const alturaAtual = this.alturaVirtualScrollerAntesPreview ?? this.obterAlturaVirtualScrollerPx(scrollBody);
        if (alturaAtual >= this.PREVIEW_LINHA_ALTURA_LIMITE) {
          return;
        }

        if (this.alturaVirtualScrollerAntesPreview == null) {
          this.alturaVirtualScrollerAntesPreview = alturaAtual;
        }

        scrollBody.style.height = `${this.alturaVirtualScrollerAntesPreview + this.PREVIEW_LINHA_EXTRA_ALTURA}px`;
        return;
      }

      if (this.alturaVirtualScrollerAntesPreview != null) {
        scrollBody.style.height = `${this.alturaVirtualScrollerAntesPreview}px`;
        this.alturaVirtualScrollerAntesPreview = null;
        return;
      }

      this.dataTable?.scroller?.calculateAutoSize();
    }, 0);
  }

  private getTableScrollBody(): HTMLElement | null {
    return this.tableWrapper?.nativeElement?.querySelector('.p-virtualscroller') ?? null;
  }

  private salvarEstadoTela(): void {
    const scrollBody = this.getTableScrollBody();
    const itemSize = this.virtualRowHeight;
    const rowIndex = scrollBody ? Math.max(0, Math.floor((scrollBody.scrollTop ?? 0) / itemSize)) : 0;
    const rowRef = this.data?.[rowIndex];
    const estado = {
      filtros: {
        rangeDate: this.rangeDate,
        estacao_id: this.estacao_id,
        grupo: this.grupo,
        cliente: this.cliente,
        sensor: this.sensor,
        plu_filtro: this.plu_filtro,
        flu_filtro: this.flu_filtro,
        integrador_filtro: this.integrador_filtro,
        coletor_filtro: this.coletor_filtro,
        versao: this.versao,
        exibirFiltroAvancado: this.exibirFiltroAvancado,
      },
      scroll: {
        top: scrollBody?.scrollTop ?? 0,
        left: scrollBody?.scrollLeft ?? 0,
        rowIndex,
        rowId: rowRef?.estacao_id ?? null,
      },
    };

    sessionStorage.setItem(MONITORAMENTO_ESTACOES_STATE_KEY, JSON.stringify(estado));
  }

  private obterEstadoRestauracao(): any | null {
    const bruto = sessionStorage.getItem(MONITORAMENTO_ESTACOES_STATE_KEY);
    if (!bruto) {
      return null;
    }

    sessionStorage.removeItem(MONITORAMENTO_ESTACOES_STATE_KEY);

    try {
      return JSON.parse(bruto);
    } catch {
      return null;
    }
  }

  private restaurarScrollDaTela(tentativa: number = 0): void {
    if (!this.scrollRestauracaoPendente) {
      this.scrollParaUltimoDiaFiltrado();
      return;
    }

    if (tentativa === 0 && this.dataTable) {
      let indice = this.scrollRestauracaoPendente.rowIndex ?? 0;
      if (this.scrollRestauracaoPendente.rowId != null) {
        const indicePorId = this.data.findIndex((item: any) => item?.estacao_id === this.scrollRestauracaoPendente?.rowId);
        if (indicePorId >= 0) {
          indice = indicePorId;
        }
      }

      try {
        this.dataTable.scrollToVirtualIndex(indice);
      } catch {}
    }

    const scrollBody = this.getTableScrollBody();
    if (!scrollBody) {
      if (tentativa < 8) {
        setTimeout(() => this.restaurarScrollDaTela(tentativa + 1), 150);
      }
      return;
    }

    scrollBody.scrollTop = this.scrollRestauracaoPendente.top ?? 0;
    scrollBody.scrollLeft = this.scrollRestauracaoPendente.left ?? 0;

    if (tentativa < 4) {
      setTimeout(() => this.restaurarScrollDaTela(tentativa + 1), 120);
      return;
    }

    this.scrollRestauracaoPendente = null;
  }

  private scrollParaUltimoDiaFiltrado(): void {
    const scrollBody = this.getTableScrollBody();
    if (!scrollBody) {
      return;
    }

    scrollBody.scrollLeft = scrollBody.scrollWidth;
  }

  onVersaoChange(): void {
    this.linhaPreviewCompletaEstacaoId = null;
    this.alturaVirtualScrollerAntesPreview = null;
    setTimeout(() => {
      this.calculateScrollHeight();
      this.limitarScrollVerticalGrid();
    }, 500);
  }

abrirRelatorio(): void {
  this.router.navigate(['/monitoramento-estacoes/relatorio'], {
    state: {
      rangeDate: this.rangeDate,
      estacao_id: this.estacao_id,
      grupo: this.grupo,
      cliente: this.cliente,
      sensor: this.sensor,
      plu_filtro: this.plu_filtro,
      flu_filtro: this.flu_filtro,
      integrador_filtro: this.integrador_filtro,
      coletor_filtro: this.coletor_filtro
    }
  });
}

abrirRelatorioEventos(): void {
  this.router.navigate(['/monitoramento-estacoes/relatorio-eventos'], {
    state: {
      rangeDate: this.rangeDate,
      estacao_id: this.estacao_id,
      grupo: this.grupo,
      cliente: this.cliente,
      sensor: this.sensor,
      plu_filtro: this.plu_filtro,
      flu_filtro: this.flu_filtro,
      integrador_filtro: this.integrador_filtro,
      coletor_filtro: this.coletor_filtro
    }
  });
}

}
